import { createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createBlock as _createBlock, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-529abd32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nge-profile-tabbar" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 0,
  class: "nge-profile-body nge-profile-body--overview"
}
const _hoisted_4 = {
  key: 0,
  class: "nge-profile-header"
}
const _hoisted_5 = { class: "nge-profile-header-main" }
const _hoisted_6 = { class: "nge-profile-name-row" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 0,
  class: "nge-profile-flag-picker"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 1,
  class: "nge-profile-flag-wrap"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]
const _hoisted_16 = ["title"]
const _hoisted_17 = {
  key: 0,
  class: "nge-profile-bio"
}
const _hoisted_18 = { class: "nge-profile-header-side" }
const _hoisted_19 = {
  key: 0,
  class: "nge-profile-section nge-profile-section--badges nge-profile-section--special"
}
const _hoisted_20 = {
  key: 0,
  class: "nge-profile-section-label"
}
const _hoisted_21 = { class: "nge-profile-badges-grid" }
const _hoisted_22 = ["title", "onClick"]
const _hoisted_23 = { class: "nge-profile-badge-img" }
const _hoisted_24 = ["src", "alt"]
const _hoisted_25 = { class: "nge-profile-badge-name" }
const _hoisted_26 = {
  key: 0,
  class: "nge-profile-medal-gap",
  "aria-hidden": "true"
}
const _hoisted_27 = ["title", "onClick"]
const _hoisted_28 = { class: "nge-profile-badge-img" }
const _hoisted_29 = ["src", "alt"]
const _hoisted_30 = ["aria-label"]
const _hoisted_31 = { class: "nge-profile-badge-name" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-badge-img" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "nge-profile-badge-viewall-icon",
    viewBox: "0 0 24 24",
    fill: "none",
    "aria-hidden": "true"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M4 12h14M13 6l6 6-6 6",
      stroke: "currentColor",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1 /* HOISTED */))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-badge-name" }, "View all", -1 /* HOISTED */))
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = { class: "nge-profile-section nge-profile-section--identified" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-section-label" }, "▌ Cells identified", -1 /* HOISTED */))
const _hoisted_37 = { class: "nge-profile-stat-row nge-profile-stat-row--tiles" }
const _hoisted_38 = ["title"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-stat-label" }, "All time", -1 /* HOISTED */))
const _hoisted_40 = {
  key: 0,
  class: "nge-profile-stat-val nge-profile-stat-val--na",
  title: "Not available right now"
}
const _hoisted_41 = {
  key: 1,
  class: "nge-profile-stat-val nge-profile-stat-val--hero"
}
const _hoisted_42 = { class: "nge-track-rows" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nge-profile-section-label",
  title: "Cells proofread all the way to completion in Pyr, on any of its datasets; a cell completed again after an edit counts once. Cells marked in other tools are not counted. At the right, your Cell Completion Achievements."
}, "▌ Cells completed", -1 /* HOISTED */))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nge-track-wire",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nge-track-pads",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_46 = ["title"]
const _hoisted_47 = ["title"]
const _hoisted_48 = { class: "nge-track-stats" }
const _hoisted_49 = { class: "nge-profile-section nge-profile-section--completions nge-profile-section--windows" }
const _hoisted_50 = {
  key: 0,
  class: "nge-profile-stat-unavailable"
}
const _hoisted_51 = {
  key: 1,
  class: "nge-profile-feature-row"
}
const _hoisted_52 = { class: "nge-profile-windows" }
const _hoisted_53 = { class: "nge-profile-stat-row" }
const _hoisted_54 = { class: "nge-profile-stat-label" }
const _hoisted_55 = { class: "nge-profile-stat-val" }
const _hoisted_56 = { class: "nge-track-achievements" }
const _hoisted_57 = { class: "nge-profile-section nge-profile-section--badges" }
const _hoisted_58 = { class: "nge-profile-badges-grid" }
const _hoisted_59 = ["title", "onClick"]
const _hoisted_60 = { class: "nge-profile-badge-img" }
const _hoisted_61 = ["src", "alt"]
const _hoisted_62 = { class: "nge-profile-badge-name" }
const _hoisted_63 = {
  key: 0,
  class: "nge-profile-badge nge-profile-badge--locked",
  title: 'Next: complete more cells to unlock!'
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-badge-img" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-badge-mystery" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "nge-profile-badge-mystery-q" }, "?")
  ])
], -1 /* HOISTED */))
const _hoisted_65 = [
  _hoisted_64
]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-badge-img" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "nge-profile-badge-viewall-icon",
    viewBox: "0 0 24 24",
    fill: "none",
    "aria-hidden": "true"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M4 12h14M13 6l6 6-6 6",
      stroke: "currentColor",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1 /* HOISTED */))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-badge-name" }, "View all", -1 /* HOISTED */))
const _hoisted_68 = [
  _hoisted_66,
  _hoisted_67
]
const _hoisted_69 = {
  key: 0,
  class: "nge-profile-badges-empty"
}
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nge-profile-section-label",
  title: "Splits and merges you made in Pyr, on any of its datasets; edits made in other tools, or before you joined, are not counted. At the right, your Editor Achievements."
}, "▌ Edits in Pyr", -1 /* HOISTED */))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nge-track-wire",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nge-track-pads",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_73 = ["title"]
const _hoisted_74 = ["title"]
const _hoisted_75 = { class: "nge-track-stats" }
const _hoisted_76 = { class: "nge-profile-section nge-profile-section--edits nge-profile-section--windows" }
const _hoisted_77 = { class: "nge-profile-feature-row" }
const _hoisted_78 = { class: "nge-profile-windows" }
const _hoisted_79 = { class: "nge-profile-stat-row" }
const _hoisted_80 = { class: "nge-profile-stat-label" }
const _hoisted_81 = { class: "nge-profile-stat-val" }
const _hoisted_82 = { class: "nge-profile-stat-breakdown" }
const _hoisted_83 = {
  class: "nge-profile-stat-bp",
  title: "Merges"
}
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "nge-profile-stat-icon nge-profile-stat-icon--merge",
  viewBox: "0 0 16 16",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4 3v4a4 4 0 0 0 4 4h0a4 4 0 0 0 4-4V3",
    stroke: "currentColor",
    "stroke-width": "1.8",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "4",
    cy: "2.5",
    r: "1.5",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "2.5",
    r: "1.5",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "8",
    cy: "13",
    r: "1.5",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8 11v2",
    stroke: "currentColor",
    "stroke-width": "1.8",
    "stroke-linecap": "round"
  })
], -1 /* HOISTED */))
const _hoisted_85 = {
  class: "nge-profile-stat-bp",
  title: "Splits"
}
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "nge-profile-stat-icon nge-profile-stat-icon--split",
  viewBox: "0 0 16 16",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8 3v2a4 4 0 0 1-4 4H4",
    stroke: "currentColor",
    "stroke-width": "1.8",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8 3v2a4 4 0 0 0 4 4h0",
    stroke: "currentColor",
    "stroke-width": "1.8",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "8",
    cy: "2.5",
    r: "1.5",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "4",
    cy: "13",
    r: "1.5",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "13",
    r: "1.5",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4 9v4M12 9v4",
    stroke: "currentColor",
    "stroke-width": "1.8",
    "stroke-linecap": "round"
  })
], -1 /* HOISTED */))
const _hoisted_87 = { class: "nge-track-achievements" }
const _hoisted_88 = { class: "nge-profile-section nge-profile-section--badges" }
const _hoisted_89 = { class: "nge-profile-badges-grid" }
const _hoisted_90 = ["title", "onClick"]
const _hoisted_91 = { class: "nge-profile-badge-img" }
const _hoisted_92 = ["src", "alt"]
const _hoisted_93 = { class: "nge-profile-badge-name" }
const _hoisted_94 = {
  key: 0,
  class: "nge-profile-badge nge-profile-badge--locked",
  title: 'Next: keep editing to unlock!'
}
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-badge-img" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-badge-mystery" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "nge-profile-badge-mystery-q" }, "?")
  ])
], -1 /* HOISTED */))
const _hoisted_96 = [
  _hoisted_95
]
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-badge-img" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "nge-profile-badge-viewall-icon",
    viewBox: "0 0 24 24",
    fill: "none",
    "aria-hidden": "true"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M4 12h14M13 6l6 6-6 6",
      stroke: "currentColor",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1 /* HOISTED */))
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-badge-name" }, "View all", -1 /* HOISTED */))
const _hoisted_99 = [
  _hoisted_97,
  _hoisted_98
]
const _hoisted_100 = {
  key: 0,
  class: "nge-profile-badges-empty"
}
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nge-profile-section-label",
  title: "Every day you have shown up, ever. At the right, your Days Achievements."
}, "▌ Days helping science in Pyr", -1 /* HOISTED */))
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nge-track-wire",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nge-track-pads",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_104 = ["title"]
const _hoisted_105 = ["title"]
const _hoisted_106 = { class: "nge-track-stats" }
const _hoisted_107 = {
  key: 0,
  class: "nge-profile-section nge-profile-section--days"
}
const _hoisted_108 = { class: "nge-profile-days-row" }
const _hoisted_109 = {
  class: "nge-profile-stat-col",
  title: "Every day you have shown up, ever. This never resets."
}
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-stat-label" }, "Total days", -1 /* HOISTED */))
const _hoisted_111 = { class: "nge-profile-stat-val nge-profile-stat-val--hero" }
const _hoisted_112 = ["title"]
const _hoisted_113 = { class: "nge-track-achievements" }
const _hoisted_114 = {
  key: 0,
  class: "nge-profile-section nge-profile-section--badges"
}
const _hoisted_115 = { class: "nge-profile-badges-grid" }
const _hoisted_116 = ["title", "onClick"]
const _hoisted_117 = { class: "nge-profile-badge-img" }
const _hoisted_118 = ["src", "alt"]
const _hoisted_119 = { class: "nge-profile-badge-name" }
const _hoisted_120 = ["title"]
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-badge-img" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-badge-mystery" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "nge-profile-badge-mystery-q" }, "?")
  ])
], -1 /* HOISTED */))
const _hoisted_122 = [
  _hoisted_121
]
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-badge-img" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "nge-profile-badge-viewall-icon",
    viewBox: "0 0 24 24",
    fill: "none",
    "aria-hidden": "true"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M4 12h14M13 6l6 6-6 6",
      stroke: "currentColor",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1 /* HOISTED */))
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-badge-name" }, "View all", -1 /* HOISTED */))
const _hoisted_125 = [
  _hoisted_123,
  _hoisted_124
]
const _hoisted_126 = {
  key: 0,
  class: "nge-profile-badges-empty"
}
const _hoisted_127 = { class: "nge-track-stats" }
const _hoisted_128 = { class: "nge-profile-section nge-profile-section--cells" }
const _hoisted_129 = {
  key: 0,
  class: "nge-cell-list"
}
const _hoisted_130 = { class: "nge-cell-list-header" }
const _hoisted_131 = { class: "nge-cell-list-title" }
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-cell-list-columns" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "nge-cell-col-label nge-cell-col-label--id" }, "Segment"),
  /*#__PURE__*/_createElementVNode("span", { class: "nge-cell-col-label nge-cell-col-label--type" }, "Type"),
  /*#__PURE__*/_createElementVNode("span", { class: "nge-cell-col-label nge-cell-col-label--time" }, "When")
], -1 /* HOISTED */))
const _hoisted_133 = { class: "nge-cell-list-scroll" }
const _hoisted_134 = ["title"]
const _hoisted_135 = ["onClick"]
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-cell-fav nge-cell-fav--none",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_137 = ["onClick"]
const _hoisted_138 = ["title", "onClick"]
const _hoisted_139 = ["onClick"]
const _hoisted_140 = ["onClick"]
const _hoisted_141 = {
  key: 3,
  class: "nge-cell-rename",
  "aria-hidden": "true"
}
const _hoisted_142 = {
  key: 1,
  class: "nge-cell-empty"
}
const _hoisted_143 = { class: "nge-track-achievements nge-track-achievements--rest" }
const _hoisted_144 = { class: "nge-profile-section nge-profile-section--scout" }
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-section-label" }, "▌ Scout Report", -1 /* HOISTED */))
const _hoisted_146 = {
  class: "nge-profile-stat-row nge-profile-stat-row--scout",
  style: {"margin-bottom":"12px"}
}
const _hoisted_147 = {
  class: "nge-profile-stat-col",
  title: "Tags you placed for others to fix"
}
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-stat-label" }, "Tags Placed", -1 /* HOISTED */))
const _hoisted_149 = {
  class: "nge-profile-stat-val",
  style: {"color":"#f5d142"}
}
const _hoisted_150 = {
  class: "nge-profile-stat-col",
  title: "Tags of yours that someone fixed"
}
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-stat-label" }, "Confirmed", -1 /* HOISTED */))
const _hoisted_152 = { class: "nge-profile-stat-val" }
const _hoisted_153 = {
  class: "nge-profile-stat-col",
  title: "Tags you fixed for others"
}
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-stat-label" }, "You Fixed", -1 /* HOISTED */))
const _hoisted_155 = {
  class: "nge-profile-stat-val",
  style: {"color":"#9d9"}
}
const _hoisted_156 = {
  class: "nge-profile-stat-col",
  title: "Other players' help requests you replied to, one each, on every dataset"
}
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-stat-label" }, "Assists", -1 /* HOISTED */))
const _hoisted_158 = {
  class: "nge-profile-stat-val",
  style: {"color":"#7f8"}
}
const _hoisted_159 = {
  class: "nge-profile-stat-col",
  title: "Points, lines and boxes you placed in annotation layers, on every dataset"
}
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-stat-label" }, "Annotations", -1 /* HOISTED */))
const _hoisted_161 = {
  class: "nge-profile-stat-val",
  style: {"color":"#c9a0ff","text-shadow":"0 0 14px rgba(201, 160, 255, 0.35)"}
}
const _hoisted_162 = {
  class: "nge-profile-stat-col",
  title: "Annotation quests you completed: cells whose cilia you marked and sent to the lab's sheet"
}
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-stat-label" }, "Quests", -1 /* HOISTED */))
const _hoisted_164 = {
  class: "nge-profile-stat-val",
  style: {"color":"#7fe0ff","text-shadow":"0 0 14px rgba(127, 224, 255, 0.35)"}
}
const _hoisted_165 = {
  key: 1,
  class: "nge-profile-stat-na",
  title: "The quest sheet could not be read just now"
}
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-section-label" }, "▌ Annotations and Assists", -1 /* HOISTED */))
const _hoisted_167 = {
  class: "nge-profile-stat-row",
  style: {"margin-bottom":"12px"}
}
const _hoisted_168 = {
  class: "nge-profile-stat-col",
  title: "Points, lines and boxes this player has placed in annotation layers, on every dataset"
}
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-stat-label" }, "Annotations", -1 /* HOISTED */))
const _hoisted_170 = {
  class: "nge-profile-stat-val",
  style: {"color":"#c9a0ff","text-shadow":"0 0 14px rgba(201, 160, 255, 0.35)"}
}
const _hoisted_171 = {
  class: "nge-profile-stat-col",
  title: "Other players' help requests this player replied to, one each, on every dataset"
}
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-stat-label" }, "Assists", -1 /* HOISTED */))
const _hoisted_173 = {
  class: "nge-profile-stat-val",
  style: {"color":"#7f8"}
}
const _hoisted_174 = {
  key: 0,
  class: "nge-profile-section nge-profile-section--building"
}
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-section-label" }, "▌ Building Pyr", -1 /* HOISTED */))
const _hoisted_176 = { class: "nge-profile-stat-row nge-profile-stat-row--tiles" }
const _hoisted_177 = {
  class: "nge-profile-stat-col nge-profile-stat-tile nge-profile-stat-tile--build",
  title: "Changes saved to Pyr's code"
}
const _hoisted_178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-stat-label" }, "Commits", -1 /* HOISTED */))
const _hoisted_179 = { class: "nge-profile-stat-val nge-profile-stat-val--hero" }
const _hoisted_180 = {
  class: "nge-profile-stat-col nge-profile-stat-tile nge-profile-stat-tile--build",
  title: "Times a new version of Pyr has gone live"
}
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-stat-label" }, "Deploys", -1 /* HOISTED */))
const _hoisted_182 = { class: "nge-profile-stat-val nge-profile-stat-val--hero" }
const _hoisted_183 = { class: "nge-profile-col nge-profile-col--right" }
const _hoisted_184 = {
  key: "special",
  class: "nge-profile-viz-panel nge-profile-viz-badge nge-profile-viz-badge--detail"
}
const _hoisted_185 = ["src", "alt"]
const _hoisted_186 = { class: "nge-profile-viz-badge-name" }
const _hoisted_187 = {
  key: 0,
  class: "nge-profile-viz-badge-desc"
}
const _hoisted_188 = {
  key: 1,
  class: "nge-profile-viz-badge-desc nge-medal-wins"
}
const _hoisted_189 = { class: "nge-profile-viz-badge-threshold" }
const _hoisted_190 = {
  key: "latest",
  class: "nge-profile-viz-panel nge-profile-viz-badge"
}
const _hoisted_191 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-viz-title" }, "⭐ Favorite Achievement", -1 /* HOISTED */))
const _hoisted_192 = ["src", "alt"]
const _hoisted_193 = { class: "nge-profile-viz-badge-name" }
const _hoisted_194 = { class: "nge-profile-viz-badge-desc" }
const _hoisted_195 = { class: "nge-profile-viz-badge-threshold" }
const _hoisted_196 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-viz-title" }, "⭐ Favorite Achievement", -1 /* HOISTED */))
const _hoisted_197 = ["src", "alt"]
const _hoisted_198 = { class: "nge-profile-viz-badge-name" }
const _hoisted_199 = {
  key: 0,
  class: "nge-profile-viz-badge-desc"
}
const _hoisted_200 = { class: "nge-profile-viz-badge-threshold" }
const _hoisted_201 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-viz-title" }, "▌ Latest Achievement", -1 /* HOISTED */))
const _hoisted_202 = ["src", "alt"]
const _hoisted_203 = { class: "nge-profile-viz-badge-name" }
const _hoisted_204 = { class: "nge-profile-viz-badge-desc" }
const _hoisted_205 = { class: "nge-profile-viz-badge-threshold" }
const _hoisted_206 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-viz-title" }, "▌ Achievements", -1 /* HOISTED */))
const _hoisted_207 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nge-profile-viz-badge-desc",
  style: {"margin-top":"40px"}
}, " Make edits and complete cells to earn Achievements! ", -1 /* HOISTED */))
const _hoisted_208 = {
  key: "badge",
  class: "nge-profile-viz-panel nge-profile-viz-badge nge-profile-viz-badge--detail"
}
const _hoisted_209 = ["src", "alt"]
const _hoisted_210 = { class: "nge-profile-viz-badge-name" }
const _hoisted_211 = { class: "nge-profile-viz-badge-desc" }
const _hoisted_212 = { class: "nge-profile-viz-badge-threshold" }
const _hoisted_213 = {
  key: 0,
  class: "nge-profile-silvers"
}
const _hoisted_214 = ["title", "onClick"]
const _hoisted_215 = ["src", "alt"]
const _hoisted_216 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-trophy-fav-star" }, "★", -1 /* HOISTED */))
const _hoisted_217 = {
  key: 1,
  class: "nge-profile-silvers nge-profile-bronzes"
}
const _hoisted_218 = ["title", "onClick"]
const _hoisted_219 = ["src", "alt"]
const _hoisted_220 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-trophy-fav-star" }, "★", -1 /* HOISTED */))
const _hoisted_221 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-right-divider" }, null, -1 /* HOISTED */))
const _hoisted_222 = {
  key: 2,
  class: "nge-profile-section nge-profile-section--podium"
}
const _hoisted_223 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-section-label nge-profile-section-label--amber" }, "▌ Top of the Week", -1 /* HOISTED */))
const _hoisted_224 = {
  key: 0,
  class: "nge-profile-podium-metric"
}
const _hoisted_225 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-podium-metric-label" }, "Edits", -1 /* HOISTED */))
const _hoisted_226 = { class: "nge-profile-podium-row" }
const _hoisted_227 = ["title"]
const _hoisted_228 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-profile-podium-medal" }, "🥇", -1 /* HOISTED */))
const _hoisted_229 = { class: "nge-profile-podium-count" }
const _hoisted_230 = ["title"]
const _hoisted_231 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-profile-podium-medal" }, "🥈", -1 /* HOISTED */))
const _hoisted_232 = { class: "nge-profile-podium-count" }
const _hoisted_233 = ["title"]
const _hoisted_234 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-profile-podium-medal" }, "🥉", -1 /* HOISTED */))
const _hoisted_235 = { class: "nge-profile-podium-count" }
const _hoisted_236 = {
  key: 1,
  class: "nge-profile-podium-metric"
}
const _hoisted_237 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-podium-metric-label" }, "Cells", -1 /* HOISTED */))
const _hoisted_238 = { class: "nge-profile-podium-row" }
const _hoisted_239 = ["title"]
const _hoisted_240 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-profile-podium-medal" }, "🥇", -1 /* HOISTED */))
const _hoisted_241 = { class: "nge-profile-podium-count" }
const _hoisted_242 = ["title"]
const _hoisted_243 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-profile-podium-medal" }, "🥈", -1 /* HOISTED */))
const _hoisted_244 = { class: "nge-profile-podium-count" }
const _hoisted_245 = ["title"]
const _hoisted_246 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-profile-podium-medal" }, "🥉", -1 /* HOISTED */))
const _hoisted_247 = { class: "nge-profile-podium-count" }
const _hoisted_248 = { class: "nge-profile-section nge-profile-section--streak" }
const _hoisted_249 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-section-label nge-profile-section-label--amber" }, "▌ Streak", -1 /* HOISTED */))
const _hoisted_250 = {
  key: 0,
  class: "nge-profile-streak-row"
}
const _hoisted_251 = { class: "nge-profile-streak-current" }
const _hoisted_252 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-profile-streak-flame" }, "🔥", -1 /* HOISTED */))
const _hoisted_253 = { class: "nge-profile-streak-count" }
const _hoisted_254 = { class: "nge-profile-streak-unit" }
const _hoisted_255 = {
  key: 0,
  class: "nge-profile-streak-best"
}
const _hoisted_256 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-profile-streak-best-label" }, "Best", -1 /* HOISTED */))
const _hoisted_257 = { class: "nge-profile-streak-best-val" }
const _hoisted_258 = { class: "nge-profile-activity-chart" }
const _hoisted_259 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-chart-label" }, "Last 14 Days", -1 /* HOISTED */))
const _hoisted_260 = { class: "nge-profile-chart-bars" }
const _hoisted_261 = ["title"]
const _hoisted_262 = { class: "nge-profile-chart-bar-wrap" }
const _hoisted_263 = { class: "nge-profile-chart-day" }
const _hoisted_264 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-chart-legend" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "nge-profile-chart-legend-item" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "nge-profile-chart-legend-dot nge-profile-chart-legend-dot--edit" }),
    /*#__PURE__*/_createTextVNode(" Edits ")
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "nge-profile-chart-legend-item" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "nge-profile-chart-legend-dot nge-profile-chart-legend-dot--completion" }),
    /*#__PURE__*/_createTextVNode(" Completions ")
  ])
], -1 /* HOISTED */))
const _hoisted_265 = { class: "nge-profile-body nge-profile-body--trophy" }
const _hoisted_266 = { class: "nge-trophy-scroll" }
const _hoisted_267 = { class: "nge-trophy-side" }
const _hoisted_268 = {
  key: 0,
  class: "nge-trophy-featured"
}
const _hoisted_269 = { class: "nge-trophy-featured-effects" }
const _hoisted_270 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-ring nge-trophy-ring--1" }, null, -1 /* HOISTED */))
const _hoisted_271 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-ring nge-trophy-ring--2" }, null, -1 /* HOISTED */))
const _hoisted_272 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-ring nge-trophy-ring--3" }, null, -1 /* HOISTED */))
const _hoisted_273 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-ring nge-trophy-ring--4" }, null, -1 /* HOISTED */))
const _hoisted_274 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-ring nge-trophy-ring--5" }, null, -1 /* HOISTED */))
const _hoisted_275 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-aura" }, null, -1 /* HOISTED */))
const _hoisted_276 = ["src", "alt"]
const _hoisted_277 = { class: "nge-trophy-featured-info" }
const _hoisted_278 = { class: "nge-trophy-featured-name nge-trophy-featured-name--scifi" }
const _hoisted_279 = {
  key: 0,
  class: "nge-trophy-featured-desc"
}
const _hoisted_280 = {
  key: 1,
  class: "nge-trophy-featured-desc nge-medal-wins"
}
const _hoisted_281 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nge-trophy-featured-desc",
  style: {"font-style":"italic","opacity":"0.7"}
}, "Won for being awesome", -1 /* HOISTED */))
const _hoisted_282 = { class: "nge-trophy-featured-threshold" }
const _hoisted_283 = {
  key: 2,
  class: "nge-trophy-featured-fav-label"
}
const _hoisted_284 = ["title"]
const _hoisted_285 = {
  key: 1,
  class: "nge-trophy-featured"
}
const _hoisted_286 = { class: "nge-trophy-featured-effects" }
const _hoisted_287 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-ring nge-trophy-ring--1" }, null, -1 /* HOISTED */))
const _hoisted_288 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-ring nge-trophy-ring--2" }, null, -1 /* HOISTED */))
const _hoisted_289 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-ring nge-trophy-ring--3" }, null, -1 /* HOISTED */))
const _hoisted_290 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-ring nge-trophy-ring--4" }, null, -1 /* HOISTED */))
const _hoisted_291 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-ring nge-trophy-ring--5" }, null, -1 /* HOISTED */))
const _hoisted_292 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-aura" }, null, -1 /* HOISTED */))
const _hoisted_293 = ["src", "alt"]
const _hoisted_294 = { class: "nge-trophy-featured-info" }
const _hoisted_295 = { class: "nge-trophy-featured-name nge-trophy-featured-name--scifi" }
const _hoisted_296 = {
  key: 0,
  class: "nge-trophy-featured-desc"
}
const _hoisted_297 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nge-trophy-featured-desc",
  style: {"font-style":"italic","opacity":"0.7"}
}, "Won for being awesome", -1 /* HOISTED */))
const _hoisted_298 = { class: "nge-trophy-featured-threshold" }
const _hoisted_299 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-featured-fav-label" }, "★ Your favorite badge", -1 /* HOISTED */))
const _hoisted_300 = {
  key: 2,
  class: "nge-trophy-featured"
}
const _hoisted_301 = { class: "nge-trophy-featured-effects" }
const _hoisted_302 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-ring nge-trophy-ring--1" }, null, -1 /* HOISTED */))
const _hoisted_303 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-ring nge-trophy-ring--2" }, null, -1 /* HOISTED */))
const _hoisted_304 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-ring nge-trophy-ring--3" }, null, -1 /* HOISTED */))
const _hoisted_305 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-ring nge-trophy-ring--4" }, null, -1 /* HOISTED */))
const _hoisted_306 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-ring nge-trophy-ring--5" }, null, -1 /* HOISTED */))
const _hoisted_307 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-aura" }, null, -1 /* HOISTED */))
const _hoisted_308 = ["src", "alt"]
const _hoisted_309 = { class: "nge-trophy-featured-info" }
const _hoisted_310 = { class: "nge-trophy-featured-name nge-trophy-featured-name--scifi" }
const _hoisted_311 = { class: "nge-trophy-featured-desc" }
const _hoisted_312 = { class: "nge-trophy-featured-threshold" }
const _hoisted_313 = {
  key: 0,
  class: "nge-trophy-featured-fav-label"
}
const _hoisted_314 = ["title"]
const _hoisted_315 = {
  key: 3,
  class: "nge-trophy-stars"
}
const _hoisted_316 = ["title"]
const _hoisted_317 = ["disabled", "title"]
const _hoisted_318 = ["disabled", "title"]
const _hoisted_319 = {
  key: 4,
  class: "nge-trophy-favs"
}
const _hoisted_320 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-favs-label" }, "Favorites", -1 /* HOISTED */))
const _hoisted_321 = { class: "nge-trophy-favs-row" }
const _hoisted_322 = ["draggable", "onDragstart", "onDragover", "onDrop", "title", "onClick"]
const _hoisted_323 = ["src", "alt"]
const _hoisted_324 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-trophy-fav-star" }, "★", -1 /* HOISTED */))
const _hoisted_325 = {
  key: 0,
  class: "nge-trophy-favs-row nge-trophy-favs-row--bronze"
}
const _hoisted_326 = ["draggable", "onDragstart", "onDragover", "onDrop", "title", "onClick"]
const _hoisted_327 = ["src", "alt"]
const _hoisted_328 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-trophy-fav-star" }, "★", -1 /* HOISTED */))
const _hoisted_329 = {
  key: 1,
  class: "nge-trophy-favs-empty"
}
const _hoisted_330 = { class: "nge-trophy-main" }
const _hoisted_331 = {
  class: "nge-trophy-track-label",
  style: {"color":"#90fff2"}
}
const _hoisted_332 = { class: "nge-trophy-track-count" }
const _hoisted_333 = {
  key: 0,
  class: "nge-trophy-track-move"
}
const _hoisted_334 = { class: "nge-trophy-grid" }
const _hoisted_335 = ["title", "onClick"]
const _hoisted_336 = ["src", "alt"]
const _hoisted_337 = { class: "nge-trophy-badge-name" }
const _hoisted_338 = { class: "nge-trophy-badge-threshold" }
const _hoisted_339 = {
  class: "nge-trophy-track-label",
  style: {"color":"#ffd08a"}
}
const _hoisted_340 = { class: "nge-trophy-track-count" }
const _hoisted_341 = {
  key: 0,
  class: "nge-trophy-track-move"
}
const _hoisted_342 = { class: "nge-trophy-grid" }
const _hoisted_343 = ["title", "onClick"]
const _hoisted_344 = ["src", "alt"]
const _hoisted_345 = { class: "nge-trophy-badge-name" }
const _hoisted_346 = { class: "nge-trophy-badge-threshold" }
const _hoisted_347 = {
  class: "nge-trophy-track-label",
  style: {"color":"#c9a8ff"}
}
const _hoisted_348 = { class: "nge-trophy-track-count" }
const _hoisted_349 = {
  key: 0,
  class: "nge-trophy-track-move"
}
const _hoisted_350 = { class: "nge-trophy-grid" }
const _hoisted_351 = ["title", "onClick"]
const _hoisted_352 = ["src", "alt"]
const _hoisted_353 = { class: "nge-trophy-badge-name" }
const _hoisted_354 = { class: "nge-trophy-badge-threshold" }
const _hoisted_355 = { class: "nge-trophy-track-label" }
const _hoisted_356 = {
  key: 0,
  class: "nge-trophy-track-move"
}
const _hoisted_357 = { class: "nge-trophy-grid" }
const _hoisted_358 = ["title", "onClick"]
const _hoisted_359 = { class: "nge-trophy-medal-img" }
const _hoisted_360 = ["src", "alt"]
const _hoisted_361 = ["aria-label"]
const _hoisted_362 = { class: "nge-trophy-badge-name" }
const _hoisted_363 = {
  key: 0,
  class: "nge-trophy-medal-place"
}
const _hoisted_364 = { class: "nge-trophy-track-label" }
const _hoisted_365 = {
  key: 0,
  class: "nge-trophy-track-move"
}
const _hoisted_366 = { class: "nge-trophy-grid" }
const _hoisted_367 = ["title", "onClick"]
const _hoisted_368 = ["src", "alt"]
const _hoisted_369 = { class: "nge-trophy-badge-name" }
const _hoisted_370 = {
  key: 2,
  class: "nge-profile-body nge-profile-body--mycells"
}
const _hoisted_371 = {
  key: 3,
  class: "nge-profile-body nge-profile-body--datasets"
}
const _hoisted_372 = { class: "nge-ds-tab-intro" }
const _hoisted_373 = {
  key: 0,
  class: "nge-ds-access"
}
const _hoisted_374 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-ds-access-title" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "nge-ds-access-tick",
    "aria-hidden": "true"
  }),
  /*#__PURE__*/_createTextVNode("Edit access")
], -1 /* HOISTED */))
const _hoisted_375 = { class: "nge-ds-access-row" }
const _hoisted_376 = ["title"]
const _hoisted_377 = ["src"]
const _hoisted_378 = { class: "nge-ds-access-text" }
const _hoisted_379 = { class: "nge-ds-access-name" }
const _hoisted_380 = { class: "nge-ds-access-state" }
const _hoisted_381 = {
  key: 1,
  class: "nge-ds-tab-loading"
}
const _hoisted_382 = {
  key: 2,
  class: "nge-ds-tab-loading"
}
const _hoisted_383 = { class: "nge-ds-tab-grid" }
const _hoisted_384 = ["onClick"]
const _hoisted_385 = ["src"]
const _hoisted_386 = { class: "nge-ds-tab-card-body" }
const _hoisted_387 = { class: "nge-ds-tab-card-head" }
const _hoisted_388 = {
  key: 0,
  class: "nge-ds-tab-species"
}
const _hoisted_389 = { class: "nge-ds-tab-label" }
const _hoisted_390 = {
  key: 1,
  class: "nge-ds-tab-badge"
}
const _hoisted_391 = {
  key: 2,
  class: "nge-ds-tab-switch"
}
const _hoisted_392 = { class: "nge-ds-tab-desc" }
const _hoisted_393 = {
  key: 0,
  class: "nge-ds-origin"
}
const _hoisted_394 = { class: "nge-ds-tab-stats" }
const _hoisted_395 = {
  key: 0,
  class: "nge-ds-tab-stat"
}
const _hoisted_396 = {
  key: 2,
  class: "nge-ds-tab-stat nge-ds-tab-stat--cells",
  title: "From the dataset's own records, for work done outside EyeWire II. It does not count toward Achievements, the leaderboard or cells completed."
}
const _hoisted_397 = {
  key: 3,
  class: "nge-ds-tab-stat"
}
const _hoisted_398 = {
  key: 4,
  class: "nge-ds-tab-stat nge-ds-tab-stat--none"
}
const _hoisted_399 = {
  key: 1,
  class: "nge-ds-tab-stat nge-ds-tab-stat--none"
}
const _hoisted_400 = {
  key: 4,
  class: "nge-profile-body nge-ds-more"
}
const _hoisted_401 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-ds-more-title" }, "More datasets", -1 /* HOISTED */))
const _hoisted_402 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-ds-more-intro" }, "Turn on extra datasets to add them to your dataset switcher. These are for exploring: you can look around, colour cells and share views, but there is nothing to proofread or claim in them.", -1 /* HOISTED */))
const _hoisted_403 = ["checked", "onChange"]
const _hoisted_404 = { class: "nge-ds-more-icon" }
const _hoisted_405 = { class: "nge-ds-more-text" }
const _hoisted_406 = { class: "nge-ds-more-label" }
const _hoisted_407 = { class: "nge-ds-more-desc" }
const _hoisted_408 = {
  key: 0,
  class: "nge-ds-origin"
}
const _hoisted_409 = {
  key: 5,
  class: "nge-profile-body nge-profile-body--dstats"
}
const _hoisted_410 = {
  key: 6,
  class: "nge-profile-body nge-profile-body--week"
}
const _hoisted_411 = {
  key: 7,
  class: "nge-profile-body nge-profile-body--admin"
}
const _hoisted_412 = {
  key: 8,
  class: "nge-profile-body nge-profile-body--admin"
}
const _hoisted_413 = {
  key: 9,
  class: "nge-profile-body nge-profile-body--settings"
}
const _hoisted_414 = { class: "nge-special-modal" }
const _hoisted_415 = { class: "nge-special-modal-head" }
const _hoisted_416 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-special-modal-title" }, "★ All Special Awards", -1 /* HOISTED */))
const _hoisted_417 = { class: "nge-special-modal-grid" }
const _hoisted_418 = ["title", "onClick"]
const _hoisted_419 = ["src", "alt"]
const _hoisted_420 = { class: "nge-special-modal-name" }
const _hoisted_421 = {
  key: 0,
  class: "nge-special-modal-reason"
}
const _hoisted_422 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-badge-zoom-halo" }, null, -1 /* HOISTED */))
const _hoisted_423 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-badge-zoom-ring" }, null, -1 /* HOISTED */))
const _hoisted_424 = ["src", "alt"]
const _hoisted_425 = { class: "nge-badge-zoom-name" }
const _hoisted_426 = {
  key: 0,
  class: "nge-badge-zoom-desc"
}
const _hoisted_427 = {
  key: 1,
  class: "nge-badge-zoom-meta"
}
const _hoisted_428 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-badge-zoom-hint" }, "Tap anywhere to close", -1 /* HOISTED */))

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock($setup["ModalOverlay"], {
    id: "nge-profile-modal",
    class: _normalizeClass(["nge-profile-modal", { 'nge-profile-closing': $setup.closing }]),
    onHide: $setup.handleClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref: "shellEl",
        class: _normalizeClass(["nge-profile-shell", { 'nge-profile-shell--trophy': $setup.activeTab === 'trophyCase', 'nge-profile-shell--admin': $setup.activeTab === 'adminHub', 'nge-profile-shell--week': $setup.activeTab === 'weekInScience', 'nge-profile-shell--datasets': $setup.activeTab === 'datasets', 'nge-profile-shell--dstats': $setup.activeTab === 'datasetStats', 'nge-profile-shell--settings': $setup.activeTab === 'settings' }])
      }, [
        _createCommentVNode(" The \"Researcher profile\" bar went (Ames 2026-10-22: \"the top bar can go, put X on same line\n           as Overview\"): the × closes from the end of the tab row. "),
        _createCommentVNode(" ── Tab bar ─────────────────────────────────────────── "),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("button", {
            class: _normalizeClass(["nge-profile-tab", { 'nge-profile-tab--active': $setup.activeTab === 'overview' }]),
            onClick: _cache[0] || (_cache[0] = $event => ($setup.activeTab = 'overview'))
          }, "Overview", 2 /* CLASS */),
          _createElementVNode("button", {
            class: _normalizeClass(["nge-profile-tab", { 'nge-profile-tab--active': $setup.activeTab === 'trophyCase' }]),
            onClick: _cache[1] || (_cache[1] = $event => ($setup.activeTab = 'trophyCase'))
          }, "🏆 Trophy Case", 2 /* CLASS */),
          _createElementVNode("button", {
            class: _normalizeClass(["nge-profile-tab", { 'nge-profile-tab--active': $setup.activeTab === 'myCells' }]),
            onClick: _cache[2] || (_cache[2] = $event => ($setup.activeTab = 'myCells'))
          }, "🔬 " + _toDisplayString($setup.viewingOtherUser ? 'Cells' : 'My Cells'), 3 /* TEXT, CLASS */),
          _createElementVNode("button", {
            class: _normalizeClass(["nge-profile-tab", { 'nge-profile-tab--active': $setup.activeTab === 'datasets' }]),
            onClick: _cache[3] || (_cache[3] = $event => ($setup.activeTab = 'datasets'))
          }, "🧬 Datasets", 2 /* CLASS */),
          _createCommentVNode(" The whole dataset, not this person (Ames 2026-10-06). Phones use\n             the narrow panel instead, from the Datasets tab or the leaderboard. "),
          (!$setup.isMobileRef)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: _normalizeClass(["nge-profile-tab", { 'nge-profile-tab--active': $setup.activeTab === 'datasetStats' }]),
                onClick: _cache[4] || (_cache[4] = $event => ($setup.activeTab = 'datasetStats'))
              }, "📊 Dataset Stats", 2 /* CLASS */))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" Hidden by default (Amy 2026-08-11): the tab button only appears\n             while you're ON it, i.e. arrived via the toolbar Week icon or a\n             recap notification deep-link. "),
          (!$setup.viewingOtherUser && $setup.activeTab === 'weekInScience')
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: _normalizeClass(["nge-profile-tab", { 'nge-profile-tab--active': true }]),
                onClick: _cache[5] || (_cache[5] = $event => ($setup.openWeekInScience()))
              }, [
                _createElementVNode("span", {
                  class: "nge-profile-tab-svg",
                  innerHTML: $setup.recapIconSvg
                }, null, 8 /* PROPS */, _hoisted_2),
                _createTextVNode(" My Week in Science")
              ]))
            : _createCommentVNode("v-if", true),
          (!$setup.viewingOtherUser)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: _normalizeClass(["nge-profile-tab", { 'nge-profile-tab--active': $setup.activeTab === 'settings' }]),
                onClick: _cache[6] || (_cache[6] = $event => ($setup.activeTab = 'settings'))
              }, "⚙️ Settings", 2 /* CLASS */))
            : _createCommentVNode("v-if", true),
          (!$setup.viewingOtherUser && $setup.backendStore.showAdminUi)
            ? (_openBlock(), _createElementBlock("button", {
                key: 3,
                class: _normalizeClass(["nge-profile-tab", { 'nge-profile-tab--active': $setup.activeTab === 'adminHub' }]),
                onClick: _cache[7] || (_cache[7] = $event => ($setup.activeTab = 'adminHub'))
              }, "🛠 Admin Hub", 2 /* CLASS */))
            : _createCommentVNode("v-if", true),
          (!$setup.viewingOtherUser && $setup.backendStore.isBlogAuthor)
            ? (_openBlock(), _createElementBlock("button", {
                key: 4,
                class: _normalizeClass(["nge-profile-tab", { 'nge-profile-tab--active': $setup.activeTab === 'blog' }]),
                onClick: _cache[8] || (_cache[8] = $event => ($setup.activeTab = 'blog'))
              }, "✍️ Blog", 2 /* CLASS */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("button", {
            class: "nge-profile-exit nge-profile-exit--tabs",
            title: "Close",
            "aria-label": "Close the profile",
            onClick: $setup.handleClose
          }, "×")
        ]),
        _createCommentVNode(" ── Three-column body (Overview tab) ────────────────── "),
        ($setup.activeTab === 'overview')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createCommentVNode(" LEFT: stats + recent cells "),
              _createCommentVNode(" MAIN: the old left and middle columns as one area of rows, one per\n             track, so the rows line up across: a track's stats and curve beside\n             its Achievements (Ames 2026-10-11, \"make sure the rows are aligned,\n             like across cells, edits, loyalty\"). The last row holds the rest. "),
              _createElementVNode("div", {
                class: _normalizeClass(["nge-profile-col nge-profile-col--left nge-profile-col--main", { 'is-compact': $setup.compactRows, 'is-tiny': $setup.tinyRows }])
              }, [
                _createCommentVNode(" Header "),
                ($setup.sessions.length > 0 || $setup.viewingOtherUser)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createCommentVNode(" Flag (editable only for own profile) "),
                          (!$setup.viewingOtherUser)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                id: "nge-profile-flag-wrap",
                                class: "nge-profile-flag-wrap",
                                onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"]))
                              }, [
                                _createElementVNode("button", {
                                  class: _normalizeClass(["nge-profile-flag", { 'nge-profile-flag--active': $setup.showFlagPicker }]),
                                  onClick: _cache[9] || (_cache[9] = $event => ($setup.showFlagPicker = !$setup.showFlagPicker)),
                                  title: "Click to change flag"
                                }, [
                                  ($setup.isEyewireFlag($setup.profileFlag))
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: $setup.pyrIcon,
                                        class: "nge-flag-img nge-pyr-icon"
                                      }, null, 8 /* PROPS */, _hoisted_7))
                                    : ($setup.flagImgUrl($setup.profileFlag))
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 1,
                                          src: $setup.flagImgUrl($setup.profileFlag),
                                          class: "nge-flag-img"
                                        }, null, 8 /* PROPS */, _hoisted_8))
                                      : (_openBlock(), _createElementBlock("img", {
                                          key: 2,
                                          src: $setup.pyrIcon,
                                          class: "nge-flag-img nge-pyr-icon"
                                        }, null, 8 /* PROPS */, _hoisted_9))
                                ], 2 /* CLASS */),
                                _createVNode(_Transition, { name: "nge-flag-picker" }, {
                                  default: _withCtx(() => [
                                    ($setup.showFlagPicker)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.ALL_FLAGS, (f) => {
                                            return _createElementVNode("button", {
                                              key: f,
                                              class: _normalizeClass(["nge-profile-flag-opt", { 'nge-profile-flag-opt--active': $setup.prefs.flag === f }]),
                                              onClick: $event => ($setup.setFlag(f))
                                            }, [
                                              _createElementVNode("img", {
                                                src: $setup.flagImgUrl(f),
                                                class: "nge-flag-img nge-flag-img--picker"
                                              }, null, 8 /* PROPS */, _hoisted_12)
                                            ], 10 /* CLASS, PROPS */, _hoisted_11)
                                          }), 64 /* STABLE_FRAGMENT */))
                                        ]))
                                      : _createCommentVNode("v-if", true)
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                ($setup.isEyewireFlag($setup.profileFlag))
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: $setup.pyrIcon,
                                      class: "nge-flag-img nge-pyr-icon",
                                      style: {"width":"24px","height":"24px"}
                                    }, null, 8 /* PROPS */, _hoisted_14))
                                  : ($setup.flagImgUrl($setup.profileFlag))
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 1,
                                        src: $setup.flagImgUrl($setup.profileFlag),
                                        class: "nge-flag-img",
                                        style: {"width":"28px","height":"20px"}
                                      }, null, 8 /* PROPS */, _hoisted_15))
                                    : _createCommentVNode("v-if", true)
                              ])),
                          _createCommentVNode(" The username, when there is one: it is the name players know\n                   you by in chat (Ames 2026-10-11). The display name is the tooltip. "),
                          _createElementVNode("div", {
                            class: "nge-profile-name",
                            title: $setup.profileUsername ? $setup.profileName : undefined
                          }, _toDisplayString($setup.profileUsername || $setup.profileName), 9 /* TEXT, PROPS */, _hoisted_16),
                          (!$setup.viewingOtherUser)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 2,
                                class: "nge-profile-edit-btn",
                                onClick: _cache[11] || (_cache[11] = $event => ($setup.activeTab = 'settings')),
                                title: "Edit Profile — set bio, flag, and more"
                              }, "⚙"))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _createCommentVNode(" Email is deliberately NOT shown. It was rendered for whoever's\n                 profile was open, which exposed other users' addresses to\n                 anyone who clicked their name in chat. The username is the\n                 public identifier; the address stays private. "),
                        (!$setup.viewingOtherUser)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              ($setup.prefs.bio)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString($setup.prefs.bio), 1 /* TEXT */))
                                : (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    class: "nge-profile-bio-add",
                                    onClick: _cache[12] || (_cache[12] = $event => ($setup.activeTab = 'settings'))
                                  }, " + Add a bio "))
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createCommentVNode(" Special Awards and, for the builder, Building Pyr sit beside the\n                 name (Ames 2026-10-11: \"special awards are too far down\", \"move\n                 building Pyr to the top row\"). "),
                      _createElementVNode("div", _hoisted_18, [
                        _createCommentVNode(" Special Awards (admin-awarded badges) "),
                        ($setup.plainSpecialBadges.length > 0 || $setup.competitionMedals.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              ($setup.plainSpecialBadges.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, "★ Special Awards"))
                                : _createCommentVNode("v-if", true),
                              _createElementVNode("div", _hoisted_21, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.displayedSpecialBadges, (award) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: award.id,
                                    class: _normalizeClass(["nge-profile-badge", { 'nge-profile-badge--selected': $setup.selectedSpecialBadge?.id === award.id }]),
                                    title: $setup.specialBadgeTooltip(award),
                                    onClick: $event => ($setup.onSpecialBadgeClick(award))
                                  }, [
                                    _createElementVNode("div", _hoisted_23, [
                                      _createElementVNode("img", {
                                        src: award.badge?.thumbnail_url || award.badge?.image_url,
                                        alt: award.badge?.name,
                                        class: "nge-profile-badge-icon"
                                      }, null, 8 /* PROPS */, _hoisted_24)
                                    ]),
                                    _createElementVNode("div", _hoisted_25, _toDisplayString(award.badge?.name || 'Award'), 1 /* TEXT */)
                                  ], 10 /* CLASS, PROPS */, _hoisted_22))
                                }), 128 /* KEYED_FRAGMENT */)),
                                _createCommentVNode(" The Hunt medals, each once with how many times it was won (Ames 2026-10-21) "),
                                ($setup.plainSpecialBadges.length > 0 && $setup.competitionMedals.length > 0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_26))
                                  : _createCommentVNode("v-if", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.competitionMedals, (m) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: m.tier,
                                    class: _normalizeClass(["nge-profile-badge nge-profile-badge--medal", { 'nge-profile-badge--selected': $setup.medalSelected(m) }]),
                                    title: $setup.medalTooltip(m),
                                    onClick: $event => ($setup.onMedalClick(m))
                                  }, [
                                    _createElementVNode("div", _hoisted_28, [
                                      _createElementVNode("img", {
                                        src: $setup.medalArt(m),
                                        alt: $setup.MEDAL_WORD[m.tier],
                                        class: "nge-profile-badge-icon"
                                      }, null, 8 /* PROPS */, _hoisted_29),
                                      (m.count > 1)
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 0,
                                            class: "nge-medal-count",
                                            "aria-label": `won ${m.count} times`
                                          }, "×" + _toDisplayString(m.count), 9 /* TEXT, PROPS */, _hoisted_30))
                                        : _createCommentVNode("v-if", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_31, _toDisplayString($setup.MEDAL_WORD[m.tier]), 1 /* TEXT */)
                                  ], 10 /* CLASS, PROPS */, _hoisted_27))
                                }), 128 /* KEYED_FRAGMENT */)),
                                _createCommentVNode(" View All tile when overflow "),
                                ($setup.showSpecialViewAll)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      class: "nge-profile-badge nge-profile-badge--viewall",
                                      title: "View all special awards",
                                      onClick: _cache[13] || (_cache[13] = $event => ($setup.showAllSpecialModal = true))
                                    }, _hoisted_34))
                                  : _createCommentVNode("v-if", true)
                              ])
                            ]))
                          : _createCommentVNode("v-if", true),
                        _createCommentVNode(" Cells identified: cells whose type this player set, each once.\n               Beside the name until the Identification track has a row of\n               its own (Ames 2026-10-12: \"put cells identified where Building\n               Pyr is; eventually it will be a new row\"). "),
                        _createElementVNode("div", _hoisted_35, [
                          _hoisted_36,
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("div", {
                              class: "nge-profile-stat-col nge-profile-stat-tile nge-profile-stat-tile--identified",
                              title: ($setup.viewingOtherUser ? 'Cells whose type this player set' : 'Cells whose type you set') + ' in Pyr, on its real datasets (the Sandbox does not count). A cell counts once, by its latest type; Unknown or Unsure does not count. Not annotation points.'
                            }, [
                              _hoisted_39,
                              ($setup.scopedIdentifiedFailed)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_40, "n/a"))
                                : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                    _createVNode($setup["RollUp"], {
                                      value: $setup.scopedIdentified ?? 0
                                    }, null, 8 /* PROPS */, ["value"])
                                  ]))
                            ], 8 /* PROPS */, _hoisted_38)
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["nge-track-row nge-track-row--cells", { 'is-live': $setup.revealStage >= 1 }])
                  }, [
                    _createCommentVNode(" One head for the row (Ames 2026-10-11): the label, a circuit\n                   trace to a pad, a second pad the same small distance away in\n                   every row, and from it the bar toward the next Achievement,\n                   lit as far as the count has come, with how many to go at its\n                   end. The layer tabs' language, where a trace breaks at a\n                   component; the break lands where each label ends. "),
                    _createElementVNode("div", {
                      class: "nge-track-head",
                      style: _normalizeStyle({ '--frac': ($setup.nextExplorationAchievement) ? ($setup.nextExplorationAchievement).pct / 100 : 1 })
                    }, [
                      _hoisted_43,
                      _hoisted_44,
                      _hoisted_45,
                      _createElementVNode("div", {
                        class: "nge-track-bar",
                        title: ($setup.nextExplorationAchievement) ? ($setup.nextExplorationAchievement).pct + '% of the way to your next Achievement' : 'Every Achievement on this track is yours'
                      }, null, 8 /* PROPS */, _hoisted_46),
                      ($setup.nextExplorationAchievement)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "nge-track-count",
                            title: ($setup.nextExplorationAchievement).remaining.toLocaleString() + ' more cells to your next Achievement'
                          }, _toDisplayString(($setup.nextExplorationAchievement).remaining.toLocaleString()) + " to go", 9 /* TEXT, PROPS */, _hoisted_47))
                        : _createCommentVNode("v-if", true)
                    ], 4 /* STYLE */),
                    _createElementVNode("div", _hoisted_48, [
                      _createCommentVNode(" Cells completed on this dataset, in the game, by the completed\n               cell rule: the same three windows as edits, from the completions\n               list with each cell's completion moment, and the same curve\n               under them (Ames 2026-10-11). Shown on every profile. "),
                      _createElementVNode("div", _hoisted_49, [
                        ($setup.scopedCellsFailed)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_50, "Not available right now"))
                          : (_openBlock(), _createElementBlock("div", _hoisted_51, [
                              _createElementVNode("div", _hoisted_52, [
                                _createCommentVNode(" No curve on the compact layout (a laptop, or a small screen\n                   zoomed in): the draw stuttered and the sliver it had there\n                   was not worth the room (Ames 2026-10-16, Annkri's profile). "),
                                (!$setup.compactRows)
                                  ? (_openBlock(), _createBlock($setup["EffortCurve"], {
                                      key: 0,
                                      active: $setup.revealStage >= 1,
                                      days: $setup.scopedCellDays ?? [],
                                      color: "144 255 242",
                                      unit: "cells",
                                      span: $setup.curveSpan,
                                      spans: $setup.CURVE_SPANS,
                                      "onUpdate:span": $setup.setCurveSpan
                                    }, null, 8 /* PROPS */, ["active", "days", "span"]))
                                  : _createCommentVNode("v-if", true),
                                _createElementVNode("div", _hoisted_53, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([
                  {label:'Today',    val:$setup.overviewCells.today},
                  {label:'Past 7d',  val:$setup.overviewCells.week},
                  {label:'All Time', val:$setup.overviewCells.all},
                ], (col, i) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: _normalizeClass(["nge-profile-stat-col", { 'nge-profile-stat-col--all': i === 2 }]),
                                      key: i
                                    }, [
                                      _createElementVNode("div", _hoisted_54, _toDisplayString(col.label), 1 /* TEXT */),
                                      _createElementVNode("div", _hoisted_55, [
                                        _createVNode($setup["RollUp"], {
                                          value: $setup.revealStage >= 1 ? col.val : 0
                                        }, null, 8 /* PROPS */, ["value"])
                                      ])
                                    ], 2 /* CLASS */))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ])
                              ])
                            ]))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _createCommentVNode(" Cell Completions (exploration track): first, above Editor\n               Achievements (Ames 2026-10-08) "),
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("div", _hoisted_58, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.displayedExplorationBadges, (badge) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: badge.id,
                              class: _normalizeClass(["nge-profile-badge nge-profile-badge--exploration", {
                  'nge-profile-badge--selected': $setup.selectedBadge?.id === badge.id,
                  'nge-profile-badge--latest': $setup.latestEarnedBadge?.id === badge.id,
                }]),
                              title: $setup.badgeTooltip(badge),
                              onClick: $event => ($setup.onBadgeClick(badge))
                            }, [
                              _createElementVNode("div", _hoisted_60, [
                                _createElementVNode("img", {
                                  src: $setup.getBadgeUrl(badge.imageKey),
                                  alt: badge.name,
                                  class: _normalizeClass(["nge-profile-badge-icon", `nge-badge--${badge.slug}`])
                                }, null, 10 /* CLASS, PROPS */, _hoisted_61)
                              ]),
                              _createElementVNode("div", _hoisted_62, _toDisplayString(badge.name), 1 /* TEXT */)
                            ], 10 /* CLASS, PROPS */, _hoisted_59))
                          }), 128 /* KEYED_FRAGMENT */)),
                          _createCommentVNode(" Next locked badge teaser "),
                          ($setup.earnedExplorationBadges.next && !$setup.showExplorationViewAll)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_63, _hoisted_65))
                            : _createCommentVNode("v-if", true),
                          _createCommentVNode(" \"View All\" tile at end of row 2 "),
                          ($setup.showExplorationViewAll && !$setup.showAllExploration)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "nge-profile-badge nge-profile-badge--viewall",
                                title: "View all Achievements in the Trophy Case",
                                onClick: _cache[14] || (_cache[14] = $event => ($setup.activeTab = 'trophyCase'))
                              }, _hoisted_68))
                            : _createCommentVNode("v-if", true)
                        ]),
                        ($setup.earnedExplorationBadges.earned.length === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_69, " Complete your first cell to earn an Achievement! "))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createCommentVNode(" Divider between achievement tracks ")
                    ])
                  ], 2 /* CLASS */),
                  _createElementVNode("div", {
                    class: _normalizeClass(["nge-track-row nge-track-row--edits", { 'is-live': $setup.revealStage >= 2 }])
                  }, [
                    _createCommentVNode(" One head for the row (Ames 2026-10-11): the label, a circuit\n                   trace to a pad, a second pad the same small distance away in\n                   every row, and from it the bar toward the next Achievement,\n                   lit as far as the count has come, with how many to go at its\n                   end. The layer tabs' language, where a trace breaks at a\n                   component; the break lands where each label ends. "),
                    _createElementVNode("div", {
                      class: "nge-track-head",
                      style: _normalizeStyle({ '--frac': ($setup.nextBuildingAchievement) ? ($setup.nextBuildingAchievement).pct / 100 : 1 })
                    }, [
                      _hoisted_70,
                      _hoisted_71,
                      _hoisted_72,
                      _createElementVNode("div", {
                        class: "nge-track-bar",
                        title: ($setup.nextBuildingAchievement) ? ($setup.nextBuildingAchievement).pct + '% of the way to your next Achievement' : 'Every Achievement on this track is yours'
                      }, null, 8 /* PROPS */, _hoisted_73),
                      ($setup.nextBuildingAchievement)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "nge-track-count",
                            title: ($setup.nextBuildingAchievement).remaining.toLocaleString() + ' more edits to your next Achievement'
                          }, _toDisplayString(($setup.nextBuildingAchievement).remaining.toLocaleString()) + " to go", 9 /* TEXT, PROPS */, _hoisted_74))
                        : _createCommentVNode("v-if", true)
                    ], 4 /* STYLE */),
                    _createElementVNode("div", _hoisted_75, [
                      _createCommentVNode(" Edits stats "),
                      _createElementVNode("div", _hoisted_76, [
                        _createCommentVNode(" Ames 2026-10-05: these count edits made in the game only.\n                 A player with months of earlier work elsewhere read a small\n                 number here as their work having gone missing. "),
                        _createElementVNode("div", _hoisted_77, [
                          _createElementVNode("div", _hoisted_78, [
                            _createCommentVNode(" The same rows as the three numbers, as a line from the first\n                 day to today (Ames 2026-10-11). Nothing while they load, and\n                 nothing for the career fallback, which has no days. "),
                            (!$setup.compactRows)
                              ? (_openBlock(), _createBlock($setup["EffortCurve"], {
                                  key: 0,
                                  active: $setup.revealStage >= 2,
                                  days: $setup.scopedEditDays ?? [],
                                  color: "255 208 138",
                                  unit: "edits",
                                  span: $setup.curveSpan,
                                  spans: $setup.CURVE_SPANS,
                                  "onUpdate:span": $setup.setCurveSpan
                                }, null, 8 /* PROPS */, ["active", "days", "span"]))
                              : _createCommentVNode("v-if", true),
                            _createElementVNode("div", _hoisted_79, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([
                {label:'Today',    val:$setup.overviewEdits.today.edits, merges:$setup.overviewEdits.today.merges, splits:$setup.overviewEdits.today.splits},
                {label:'Past 7d',  val:$setup.overviewEdits.week.edits,  merges:$setup.overviewEdits.week.merges,  splits:$setup.overviewEdits.week.splits},
                {label:'All Time', val:$setup.overviewEdits.all.edits,   merges:$setup.overviewEdits.all.merges,   splits:$setup.overviewEdits.all.splits},
              ], (col, i) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: _normalizeClass(["nge-profile-stat-col", { 'nge-profile-stat-col--all': i === 2 }]),
                                  key: i
                                }, [
                                  _createElementVNode("div", _hoisted_80, _toDisplayString(col.label), 1 /* TEXT */),
                                  _createElementVNode("div", _hoisted_81, [
                                    _createVNode($setup["RollUp"], {
                                      value: $setup.revealStage >= 2 ? col.val : 0
                                    }, null, 8 /* PROPS */, ["value"])
                                  ]),
                                  _createElementVNode("div", _hoisted_82, [
                                    _createElementVNode("span", _hoisted_83, [
                                      _hoisted_84,
                                      _createTextVNode(" " + _toDisplayString(col.merges), 1 /* TEXT */)
                                    ]),
                                    _createElementVNode("span", _hoisted_85, [
                                      _hoisted_86,
                                      _createTextVNode(" " + _toDisplayString(col.splits), 1 /* TEXT */)
                                    ])
                                  ])
                                ], 2 /* CLASS */))
                              }), 128 /* KEYED_FRAGMENT */))
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_87, [
                      _createCommentVNode(" Editor Achievements (building track) "),
                      _createElementVNode("div", _hoisted_88, [
                        _createElementVNode("div", _hoisted_89, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.displayedBuildingBadges, (badge) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: badge.id,
                              class: _normalizeClass(["nge-profile-badge nge-profile-badge--building", {
                  'nge-profile-badge--selected': $setup.selectedBadge?.id === badge.id,
                  'nge-profile-badge--latest': $setup.latestEarnedBadge?.id === badge.id,
                }]),
                              title: $setup.badgeTooltip(badge),
                              onClick: $event => ($setup.onBadgeClick(badge))
                            }, [
                              _createElementVNode("div", _hoisted_91, [
                                _createElementVNode("img", {
                                  src: $setup.getBadgeUrl(badge.imageKey),
                                  alt: badge.name,
                                  class: _normalizeClass(["nge-profile-badge-icon", `nge-badge--${badge.slug}`])
                                }, null, 10 /* CLASS, PROPS */, _hoisted_92)
                              ]),
                              _createElementVNode("div", _hoisted_93, _toDisplayString(badge.name), 1 /* TEXT */)
                            ], 10 /* CLASS, PROPS */, _hoisted_90))
                          }), 128 /* KEYED_FRAGMENT */)),
                          _createCommentVNode(" Next locked badge teaser "),
                          ($setup.earnedBuildingBadges.next && !$setup.showBuildingViewAll)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_94, _hoisted_96))
                            : _createCommentVNode("v-if", true),
                          _createCommentVNode(" \"View All\" tile at end of row 2 "),
                          ($setup.showBuildingViewAll && !$setup.showAllBuilding)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "nge-profile-badge nge-profile-badge--viewall",
                                title: "View all Achievements in the Trophy Case",
                                onClick: _cache[15] || (_cache[15] = $event => ($setup.activeTab = 'trophyCase'))
                              }, _hoisted_99))
                            : _createCommentVNode("v-if", true)
                        ]),
                        ($setup.earnedBuildingBadges.earned.length === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_100, " Make your first edit to earn an Achievement! "))
                          : _createCommentVNode("v-if", true)
                      ])
                    ])
                  ], 2 /* CLASS */),
                  ($setup.totalDays > 0 || $setup.LOYALTY_BADGES.length)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["nge-track-row nge-track-row--days", { 'is-live': $setup.revealStage >= 3 }])
                      }, [
                        _createCommentVNode(" One head for the row (Ames 2026-10-11): the label, a circuit\n                   trace to a pad, a second pad the same small distance away in\n                   every row, and from it the bar toward the next Achievement,\n                   lit as far as the count has come, with how many to go at its\n                   end. The layer tabs' language, where a trace breaks at a\n                   component; the break lands where each label ends. "),
                        _createElementVNode("div", {
                          class: "nge-track-head",
                          style: _normalizeStyle({ '--frac': ($setup.nextLoyaltyAchievement) ? ($setup.nextLoyaltyAchievement).pct / 100 : 1 })
                        }, [
                          _hoisted_101,
                          _hoisted_102,
                          _hoisted_103,
                          _createElementVNode("div", {
                            class: "nge-track-bar",
                            title: ($setup.nextLoyaltyAchievement) ? ($setup.nextLoyaltyAchievement).pct + '% of the way to your next Achievement' : 'Every Achievement on this track is yours'
                          }, null, 8 /* PROPS */, _hoisted_104),
                          ($setup.nextLoyaltyAchievement)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "nge-track-count",
                                title: ($setup.nextLoyaltyAchievement).remaining.toLocaleString() + ' more days to your next Achievement'
                              }, _toDisplayString(($setup.nextLoyaltyAchievement).remaining.toLocaleString()) + " to go", 9 /* TEXT, PROPS */, _hoisted_105))
                            : _createCommentVNode("v-if", true)
                        ], 4 /* STYLE */),
                        _createElementVNode("div", _hoisted_106, [
                          _createCommentVNode(" Days: total days shown up (never resets), the streaks, and the\n               ladder of milestones (Ames 2026-10-06). Three plain columns, no\n               boxes (Ames 2026-10-11). "),
                          ($setup.totalDays > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                                _createElementVNode("div", _hoisted_108, [
                                  _createCommentVNode(" The latest Days Achievement, at the left. Streak and best\n                   streak are not repeated here: they sit on the right under\n                   Streak (Ames 2026-10-11). "),
                                  _createElementVNode("div", _hoisted_109, [
                                    _hoisted_110,
                                    _createElementVNode("div", _hoisted_111, [
                                      _createVNode($setup["RollUp"], {
                                        value: $setup.revealStage >= 3 ? $setup.totalDays : 0
                                      }, null, 8 /* PROPS */, ["value"])
                                    ]),
                                    _createCommentVNode(" no pills and no bar (Ames 2026-10-06: \"unnecessary\", \"too much\"): the count says it "),
                                    _createElementVNode("div", {
                                      class: "nge-days-next",
                                      title: `Next milestone: day ${$setup.nextDay}`
                                    }, _toDisplayString(($setup.nextDay - $setup.totalDays).toLocaleString()) + " " + _toDisplayString($setup.nextDay - $setup.totalDays === 1 ? 'day' : 'days') + " to day " + _toDisplayString($setup.nextDay.toLocaleString()), 9 /* TEXT, PROPS */, _hoisted_112)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _createElementVNode("div", _hoisted_113, [
                          _createCommentVNode(" Loyalty Achievements: total days, not in a row (Ames 2026-10-06).\n               Hidden while the set is switched off (LOYALTY_ENABLED). "),
                          ($setup.LOYALTY_BADGES.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                                _createElementVNode("div", _hoisted_115, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.earnedLoyaltyBadges.earned.slice(0, $setup.ROW_RECENT), (badge) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: badge.id,
                                      class: _normalizeClass(["nge-profile-badge nge-profile-badge--loyalty", { 'nge-profile-badge--selected': $setup.selectedBadge?.id === badge.id }]),
                                      title: $setup.badgeTooltip(badge),
                                      onClick: $event => ($setup.onBadgeClick(badge))
                                    }, [
                                      _createElementVNode("div", _hoisted_117, [
                                        _createElementVNode("img", {
                                          src: $setup.getBadgeUrl(badge.imageKey),
                                          alt: badge.name,
                                          class: _normalizeClass(["nge-profile-badge-icon", `nge-badge--${badge.slug}`])
                                        }, null, 10 /* CLASS, PROPS */, _hoisted_118)
                                      ]),
                                      _createElementVNode("div", _hoisted_119, _toDisplayString(badge.name), 1 /* TEXT */)
                                    ], 10 /* CLASS, PROPS */, _hoisted_116))
                                  }), 128 /* KEYED_FRAGMENT */)),
                                  ($setup.earnedLoyaltyBadges.next && $setup.earnedLoyaltyBadges.earned.length <= $setup.ROW_RECENT)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "nge-profile-badge nge-profile-badge--locked",
                                        title: `Next: ${$setup.earnedLoyaltyBadges.next.threshold} days of science`
                                      }, _hoisted_122, 8 /* PROPS */, _hoisted_120))
                                    : _createCommentVNode("v-if", true),
                                  ($setup.earnedLoyaltyBadges.earned.length > $setup.ROW_RECENT)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        class: "nge-profile-badge nge-profile-badge--viewall",
                                        title: "View all achievements in Trophy Case",
                                        onClick: _cache[16] || (_cache[16] = $event => ($setup.activeTab = 'trophyCase'))
                                      }, _hoisted_125))
                                    : _createCommentVNode("v-if", true)
                                ]),
                                ($setup.earnedLoyaltyBadges.earned.length === 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_126, " Make an edit on two different days to earn your first Loyalty achievement! "))
                                  : _createCommentVNode("v-if", true)
                              ]))
                            : _createCommentVNode("v-if", true)
                        ])
                      ], 2 /* CLASS */))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", {
                    class: _normalizeClass(["nge-track-row nge-track-row--rest", { 'is-live': $setup.revealStage >= 4 }])
                  }, [
                    _createElementVNode("div", _hoisted_127, [
                      _createCommentVNode(" Your recently completed cells: the browser's own history, or,\n               when that is empty, the server's completions (recentCells). The\n               row takes the height left under the three above and the list\n               scrolls inside it, so the profile never scrolls as a whole\n               (Ames 2026-10-11). "),
                      _createElementVNode("div", _hoisted_128, [
                        ($setup.recentCells.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_129, [
                              _createElementVNode("div", _hoisted_130, [
                                _createElementVNode("span", _hoisted_131, _toDisplayString($setup.viewingOtherUser ? 'Recently completed cells' : 'My recently completed cells'), 1 /* TEXT */),
                                _createElementVNode("button", {
                                  class: "nge-cell-list-all",
                                  onClick: _cache[17] || (_cache[17] = $event => ($setup.activeTab = 'myCells')),
                                  title: "Every cell, by dataset"
                                }, _toDisplayString($setup.viewingOtherUser ? 'All cells' : 'My cells') + " →", 1 /* TEXT */)
                              ]),
                              _hoisted_132,
                              _createElementVNode("div", _hoisted_133, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.recentCells.slice(0, $setup.RECENT_SHOWN), (cell) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: cell.segId,
                                    class: "nge-cell-row",
                                    title: cell.nickname ? `${cell.nickname} (${cell.segId})` : `Jump to ${cell.segId}`
                                  }, [
                                    (!cell.serverOnly)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          class: _normalizeClass(["nge-cell-fav", { 'nge-cell-fav--active': cell.isFavorite }]),
                                          onClick: _withModifiers($event => ($setup.historyStore.toggleFavorite(cell.segId)), ["stop"]),
                                          title: "Toggle favorite"
                                        }, _toDisplayString(cell.isFavorite ? '★' : '☆'), 11 /* TEXT, CLASS, PROPS */, _hoisted_135))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createCommentVNode(" Its spot is kept on every row, so the columns line up (Ames 2026-10-29). "),
                                          _hoisted_136
                                        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["nge-cell-pip", $setup.cellStatusClass(cell)])
                                    }, _toDisplayString($setup.cellStatusIcon(cell)), 3 /* TEXT, CLASS */),
                                    _createElementVNode("span", {
                                      class: "nge-cell-id",
                                      onClick: $event => ($setup.handleJumpToCell(cell.segId))
                                    }, _toDisplayString(cell.nickname || $setup.truncateId(cell.segId)), 9 /* TEXT, PROPS */, _hoisted_137),
                                    _createElementVNode("span", {
                                      class: "nge-cell-type",
                                      title: cell.cellType || '',
                                      onClick: $event => ($setup.handleJumpToCell(cell.segId))
                                    }, _toDisplayString(cell.cellType || ''), 9 /* TEXT, PROPS */, _hoisted_138),
                                    _createElementVNode("span", {
                                      class: "nge-cell-time",
                                      onClick: $event => ($setup.handleJumpToCell(cell.segId))
                                    }, _toDisplayString($setup.relativeTime(cell.updatedAt)), 9 /* TEXT, PROPS */, _hoisted_139),
                                    (!cell.serverOnly)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 2,
                                          class: "nge-cell-rename",
                                          onClick: _withModifiers($event => ($setup.promptNickname(cell.segId)), ["stop"]),
                                          title: "Rename this cell"
                                        }, "✎", 8 /* PROPS */, _hoisted_140))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_141))
                                  ], 8 /* PROPS */, _hoisted_134))
                                }), 128 /* KEYED_FRAGMENT */))
                              ]),
                              ($setup.recentCells.length > $setup.RECENT_SHOWN)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "nge-cell-list-more",
                                    onClick: _cache[18] || (_cache[18] = $event => ($setup.activeTab = 'myCells'))
                                  }, _toDisplayString(($setup.recentCells.length - $setup.RECENT_SHOWN).toLocaleString()) + " more in " + _toDisplayString($setup.viewingOtherUser ? 'All cells' : 'My cells') + " →", 1 /* TEXT */))
                                : _createCommentVNode("v-if", true)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_142, [
                              _createTextVNode(" No cells completed yet. "),
                              (!$setup.viewingOtherUser)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode("Your recently completed cells will show here.")
                                  ], 64 /* STABLE_FRAGMENT */))
                                : _createCommentVNode("v-if", true)
                            ]))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_143, [
                      _createCommentVNode(" the Scout report (your tags), or another player's annotations "),
                      _createElementVNode("div", _hoisted_144, [
                        (!$setup.viewingOtherUser)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createCommentVNode(" Scout Report: tags placed and fixed "),
                              _hoisted_145,
                              _createElementVNode("div", _hoisted_146, [
                                _createElementVNode("div", _hoisted_147, [
                                  _hoisted_148,
                                  _createElementVNode("div", _hoisted_149, [
                                    _createVNode($setup["RollUp"], {
                                      value: $setup.myTagsPlaced.length
                                    }, null, 8 /* PROPS */, ["value"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_150, [
                                  _hoisted_151,
                                  _createElementVNode("div", _hoisted_152, [
                                    _createVNode($setup["RollUp"], {
                                      value: $setup.myTagsFixed.length
                                    }, null, 8 /* PROPS */, ["value"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_153, [
                                  _hoisted_154,
                                  _createElementVNode("div", _hoisted_155, [
                                    _createVNode($setup["RollUp"], {
                                      value: $setup.tagsIFixed.length
                                    }, null, 8 /* PROPS */, ["value"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_156, [
                                  _hoisted_157,
                                  _createElementVNode("div", _hoisted_158, [
                                    _createVNode($setup["RollUp"], { value: $setup.playerAssists }, null, 8 /* PROPS */, ["value"])
                                  ])
                                ]),
                                _createCommentVNode(" Annotations placed, on every dataset: a column here rather than\n                   a row of its own (Ames 2026-10-11). "),
                                _createElementVNode("div", _hoisted_159, [
                                  _hoisted_160,
                                  _createElementVNode("div", _hoisted_161, [
                                    _createVNode($setup["RollUp"], { value: $setup.annotationsPlaced }, null, 8 /* PROPS */, ["value"])
                                  ])
                                ]),
                                _createCommentVNode(" Annotation quests completed, from the quest sheet (2026-10-13). "),
                                _createElementVNode("div", _hoisted_162, [
                                  _hoisted_163,
                                  _createElementVNode("div", _hoisted_164, [
                                    ($setup.questsCompleted !== null)
                                      ? (_openBlock(), _createBlock($setup["RollUp"], {
                                          key: 0,
                                          value: $setup.questsCompleted
                                        }, null, 8 /* PROPS */, ["value"]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_165, "not available"))
                                  ])
                                ])
                              ])
                            ], 64 /* STABLE_FRAGMENT */))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _hoisted_166,
                              _createElementVNode("div", _hoisted_167, [
                                _createElementVNode("div", _hoisted_168, [
                                  _hoisted_169,
                                  _createElementVNode("div", _hoisted_170, [
                                    _createVNode($setup["RollUp"], { value: $setup.annotationsPlaced }, null, 8 /* PROPS */, ["value"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_171, [
                                  _hoisted_172,
                                  _createElementVNode("div", _hoisted_173, [
                                    _createVNode($setup["RollUp"], { value: $setup.playerAssists }, null, 8 /* PROPS */, ["value"])
                                  ])
                                ])
                              ])
                            ], 64 /* STABLE_FRAGMENT */))
                      ]),
                      _createCommentVNode(" Building Pyr: how much has been built, from GitHub. Only on\n               the profile of the person building it (Ames 2026-10-10). Under\n               the Scout report since the count of cells identified took its\n               place beside the name (Ames 2026-10-12). "),
                      ($setup.showsBuilding && $setup.repoStats)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_174, [
                            _hoisted_175,
                            _createElementVNode("div", _hoisted_176, [
                              _createElementVNode("div", _hoisted_177, [
                                _hoisted_178,
                                _createElementVNode("div", _hoisted_179, [
                                  _createVNode($setup["RollUp"], {
                                    value: $setup.repoStats.commits
                                  }, null, 8 /* PROPS */, ["value"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_180, [
                                _hoisted_181,
                                _createElementVNode("div", _hoisted_182, [
                                  _createVNode($setup["RollUp"], {
                                    value: $setup.repoStats.deploys
                                  }, null, 8 /* PROPS */, ["value"])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ], 2 /* CLASS */)
                ])
              ], 2 /* CLASS */),
              _createCommentVNode(" end main area "),
              _createCommentVNode(" RIGHT: latest badge highlight  <->  badge detail "),
              _createElementVNode("div", _hoisted_183, [
                _createVNode(_Transition, {
                  name: "nge-viz-swap",
                  mode: "out-in"
                }, {
                  default: _withCtx(() => [
                    ($setup.selectedSpecialBadge)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_184, [
                          _createElementVNode("img", {
                            src: $setup.selectedSpecialBadge.badge?.image_url || $setup.selectedSpecialBadge.badge?.thumbnail_url,
                            alt: $setup.selectedSpecialBadge.badge?.name,
                            class: "nge-profile-viz-badge-icon nge-profile-viz-badge-icon--large"
                          }, null, 8 /* PROPS */, _hoisted_185),
                          _createElementVNode("div", _hoisted_186, _toDisplayString($setup.selectedSpecialBadge.badge?.name || 'Award'), 1 /* TEXT */),
                          ($setup.selectedSpecialBadge.badge?.description)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_187, _toDisplayString($setup.selectedSpecialBadge.badge.description), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                          ($setup.medalWins($setup.selectedSpecialBadge))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_188, _toDisplayString($setup.medalWins($setup.selectedSpecialBadge)), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                          _createElementVNode("div", _hoisted_189, " Awarded " + _toDisplayString($setup.relativeTime($setup.selectedSpecialBadge.awarded_at)), 1 /* TEXT */),
                          _createElementVNode("button", {
                            class: "nge-profile-viz-badge-back",
                            onClick: _cache[19] || (_cache[19] = $event => ($setup.selectedSpecialBadge = null))
                          }, " ← Back ")
                        ]))
                      : (!$setup.selectedBadge)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createCommentVNode(" Default view: favorite badge → favorite special badge → latest earned "),
                            _createElementVNode("div", _hoisted_190, [
                              ($setup.favoriteBadge)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _hoisted_191,
                                    _createElementVNode("img", {
                                      src: $setup.getBadgeUrl($setup.favoriteBadge.imageKey),
                                      alt: $setup.favoriteBadge.name,
                                      class: _normalizeClass(["nge-profile-viz-badge-icon", `nge-badge--${$setup.favoriteBadge.slug}`])
                                    }, null, 10 /* CLASS, PROPS */, _hoisted_192),
                                    _createElementVNode("div", _hoisted_193, _toDisplayString($setup.favoriteBadge.name), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_194, _toDisplayString($setup.favoriteBadge.description), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_195, [
                                      _createTextVNode(" Unlocked at "),
                                      _createElementVNode("strong", null, _toDisplayString($setup.favoriteBadge.threshold.toLocaleString()), 1 /* TEXT */),
                                      _createTextVNode(" " + _toDisplayString($setup.thresholdLabel($setup.favoriteBadge)), 1 /* TEXT */)
                                    ])
                                  ], 64 /* STABLE_FRAGMENT */))
                                : ($setup.favoriteSpecialBadge)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _hoisted_196,
                                      _createElementVNode("img", {
                                        src: $setup.favoriteSpecialBadge.badge?.image_url || $setup.favoriteSpecialBadge.badge?.thumbnail_url,
                                        alt: $setup.favoriteSpecialBadge.badge?.name,
                                        class: "nge-profile-viz-badge-icon nge-profile-viz-badge-icon--large"
                                      }, null, 8 /* PROPS */, _hoisted_197),
                                      _createElementVNode("div", _hoisted_198, _toDisplayString($setup.favoriteSpecialBadge.badge?.name || 'Award'), 1 /* TEXT */),
                                      ($setup.favoriteSpecialBadge.badge?.description)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_199, _toDisplayString($setup.favoriteSpecialBadge.badge.description), 1 /* TEXT */))
                                        : _createCommentVNode("v-if", true),
                                      _createElementVNode("div", _hoisted_200, [
                                        _createTextVNode(" Won on "),
                                        _createElementVNode("strong", null, _toDisplayString($setup.formatDate($setup.favoriteSpecialBadge.awarded_at)), 1 /* TEXT */)
                                      ])
                                    ], 64 /* STABLE_FRAGMENT */))
                                  : ($setup.latestEarnedBadge)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        _hoisted_201,
                                        _createElementVNode("img", {
                                          src: $setup.getBadgeUrl($setup.latestEarnedBadge.imageKey),
                                          alt: $setup.latestEarnedBadge.name,
                                          class: _normalizeClass(["nge-profile-viz-badge-icon", `nge-badge--${$setup.latestEarnedBadge.slug}`])
                                        }, null, 10 /* CLASS, PROPS */, _hoisted_202),
                                        _createElementVNode("div", _hoisted_203, _toDisplayString($setup.latestEarnedBadge.name), 1 /* TEXT */),
                                        _createElementVNode("div", _hoisted_204, _toDisplayString($setup.latestEarnedBadge.description), 1 /* TEXT */),
                                        _createElementVNode("div", _hoisted_205, [
                                          _createTextVNode(" Earned at "),
                                          _createElementVNode("strong", null, _toDisplayString($setup.latestEarnedBadge.threshold.toLocaleString()), 1 /* TEXT */),
                                          _createTextVNode(" " + _toDisplayString($setup.thresholdLabel($setup.latestEarnedBadge)), 1 /* TEXT */)
                                        ])
                                      ], 64 /* STABLE_FRAGMENT */))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                        _hoisted_206,
                                        _hoisted_207
                                      ], 64 /* STABLE_FRAGMENT */))
                            ])
                          ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createCommentVNode(" Badge detail view (when a badge is clicked) "),
                            _createElementVNode("div", _hoisted_208, [
                              _createElementVNode("img", {
                                src: $setup.getBadgeUrl($setup.selectedBadge.imageKey),
                                alt: $setup.selectedBadge.name,
                                class: _normalizeClass(["nge-profile-viz-badge-icon nge-profile-viz-badge-icon--large", `nge-badge--${$setup.selectedBadge.slug}`])
                              }, null, 10 /* CLASS, PROPS */, _hoisted_209),
                              _createElementVNode("div", _hoisted_210, _toDisplayString($setup.selectedBadge.name), 1 /* TEXT */),
                              _createElementVNode("div", _hoisted_211, _toDisplayString($setup.selectedBadge.description), 1 /* TEXT */),
                              _createElementVNode("div", _hoisted_212, [
                                _createTextVNode(" Unlocked at "),
                                _createElementVNode("strong", null, _toDisplayString($setup.selectedBadge.threshold.toLocaleString()), 1 /* TEXT */),
                                _createTextVNode(" " + _toDisplayString($setup.thresholdLabel($setup.selectedBadge)), 1 /* TEXT */)
                              ]),
                              _createElementVNode("button", {
                                class: "nge-profile-viz-badge-back",
                                onClick: _cache[20] || (_cache[20] = $event => ($setup.selectedBadge = null))
                              }, " ← " + _toDisplayString($setup.favoriteBadge || $setup.favoriteSpecialBadge ? 'Back to favorite' : 'Back'), 1 /* TEXT */)
                            ])
                          ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                }),
                _createCommentVNode(" Silver favorites, under the gold one "),
                ($setup.silverRow.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_213, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.silverRow, (f) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: f.slug,
                          class: "nge-trophy-fav",
                          title: f.name + ', silver favorite',
                          onClick: $event => ($setup.openFavoriteInCase(f))
                        }, [
                          _createElementVNode("img", {
                            src: f.img,
                            alt: f.name
                          }, null, 8 /* PROPS */, _hoisted_215),
                          _hoisted_216
                        ], 8 /* PROPS */, _hoisted_214))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" Bronze favorites, a smaller strip under those "),
                ($setup.bronzeRow.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_217, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.bronzeRow, (f) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: f.slug,
                          class: "nge-trophy-fav nge-trophy-fav--bronze",
                          title: f.name + ', bronze favorite',
                          onClick: $event => ($setup.openFavoriteInCase(f))
                        }, [
                          _createElementVNode("img", {
                            src: f.img,
                            alt: f.name
                          }, null, 8 /* PROPS */, _hoisted_219),
                          _hoisted_220
                        ], 8 /* PROPS */, _hoisted_218))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" Divider between badge and streak "),
                _hoisted_221,
                _createCommentVNode(" Weekly podium counts (🥇 × N etc.) — one row per metric "),
                ($setup.anyPodium)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_222, [
                      _hoisted_223,
                      _createCommentVNode(" Edits podium "),
                      ($setup.podiumTotal > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_224, [
                            _hoisted_225,
                            _createElementVNode("div", _hoisted_226, [
                              ($setup.podium.gold > 0)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "nge-profile-podium-tile nge-profile-podium-tile--gold",
                                    title: `Finished 1st place in edits ${$setup.podium.gold} week${$setup.podium.gold === 1 ? '' : 's'}`
                                  }, [
                                    _hoisted_228,
                                    _createElementVNode("span", _hoisted_229, "× " + _toDisplayString($setup.podium.gold), 1 /* TEXT */)
                                  ], 8 /* PROPS */, _hoisted_227))
                                : _createCommentVNode("v-if", true),
                              ($setup.podium.silver > 0)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: "nge-profile-podium-tile nge-profile-podium-tile--silver",
                                    title: `Finished 2nd place in edits ${$setup.podium.silver} week${$setup.podium.silver === 1 ? '' : 's'}`
                                  }, [
                                    _hoisted_231,
                                    _createElementVNode("span", _hoisted_232, "× " + _toDisplayString($setup.podium.silver), 1 /* TEXT */)
                                  ], 8 /* PROPS */, _hoisted_230))
                                : _createCommentVNode("v-if", true),
                              ($setup.podium.bronze > 0)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 2,
                                    class: "nge-profile-podium-tile nge-profile-podium-tile--bronze",
                                    title: `Finished 3rd place in edits ${$setup.podium.bronze} week${$setup.podium.bronze === 1 ? '' : 's'}`
                                  }, [
                                    _hoisted_234,
                                    _createElementVNode("span", _hoisted_235, "× " + _toDisplayString($setup.podium.bronze), 1 /* TEXT */)
                                  ], 8 /* PROPS */, _hoisted_233))
                                : _createCommentVNode("v-if", true)
                            ])
                          ]))
                        : _createCommentVNode("v-if", true),
                      _createCommentVNode(" Completions podium "),
                      ($setup.podiumCompletionsTotal > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_236, [
                            _hoisted_237,
                            _createElementVNode("div", _hoisted_238, [
                              ($setup.podiumCompletions.gold > 0)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "nge-profile-podium-tile nge-profile-podium-tile--gold",
                                    title: `Finished 1st place in cells ${$setup.podiumCompletions.gold} week${$setup.podiumCompletions.gold === 1 ? '' : 's'}`
                                  }, [
                                    _hoisted_240,
                                    _createElementVNode("span", _hoisted_241, "× " + _toDisplayString($setup.podiumCompletions.gold), 1 /* TEXT */)
                                  ], 8 /* PROPS */, _hoisted_239))
                                : _createCommentVNode("v-if", true),
                              ($setup.podiumCompletions.silver > 0)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: "nge-profile-podium-tile nge-profile-podium-tile--silver",
                                    title: `Finished 2nd place in cells ${$setup.podiumCompletions.silver} week${$setup.podiumCompletions.silver === 1 ? '' : 's'}`
                                  }, [
                                    _hoisted_243,
                                    _createElementVNode("span", _hoisted_244, "× " + _toDisplayString($setup.podiumCompletions.silver), 1 /* TEXT */)
                                  ], 8 /* PROPS */, _hoisted_242))
                                : _createCommentVNode("v-if", true),
                              ($setup.podiumCompletions.bronze > 0)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 2,
                                    class: "nge-profile-podium-tile nge-profile-podium-tile--bronze",
                                    title: `Finished 3rd place in cells ${$setup.podiumCompletions.bronze} week${$setup.podiumCompletions.bronze === 1 ? '' : 's'}`
                                  }, [
                                    _hoisted_246,
                                    _createElementVNode("span", _hoisted_247, "× " + _toDisplayString($setup.podiumCompletions.bronze), 1 /* TEXT */)
                                  ], 8 /* PROPS */, _hoisted_245))
                                : _createCommentVNode("v-if", true)
                            ])
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" Streak + Activity Chart "),
                _createElementVNode("div", _hoisted_248, [
                  _hoisted_249,
                  ($setup.profileStats.currentStreak > 0 || $setup.profileStats.longestStreak > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_250, [
                        _createElementVNode("div", _hoisted_251, [
                          _hoisted_252,
                          _createElementVNode("span", _hoisted_253, _toDisplayString($setup.profileStats.currentStreak), 1 /* TEXT */),
                          _createElementVNode("span", _hoisted_254, "day" + _toDisplayString($setup.profileStats.currentStreak === 1 ? '' : 's') + " current", 1 /* TEXT */)
                        ]),
                        ($setup.profileStats.longestStreak > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_255, [
                              _hoisted_256,
                              _createElementVNode("span", _hoisted_257, _toDisplayString($setup.profileStats.longestStreak) + "d", 1 /* TEXT */)
                            ]))
                          : _createCommentVNode("v-if", true)
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createCommentVNode(" 14-day activity chart "),
                  _createElementVNode("div", _hoisted_258, [
                    _hoisted_259,
                    _createElementVNode("div", _hoisted_260, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.last14Days, (day) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: day.date,
                          class: "nge-profile-chart-col",
                          title: `${day.date}: ${day.edits} edits, ${day.completions} completions`
                        }, [
                          _createElementVNode("div", _hoisted_262, [
                            (day.completions > 0)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "nge-profile-chart-bar nge-profile-chart-bar--completion",
                                  style: _normalizeStyle({ height: Math.max(2, (day.completions / $setup.chartMax) * 48) + 'px' })
                                }, null, 4 /* STYLE */))
                              : _createCommentVNode("v-if", true),
                            (day.edits > 0)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  class: "nge-profile-chart-bar nge-profile-chart-bar--edit",
                                  style: _normalizeStyle({ height: Math.max(2, (day.edits / $setup.chartMax) * 48) + 'px' })
                                }, null, 4 /* STYLE */))
                              : _createCommentVNode("v-if", true)
                          ]),
                          _createElementVNode("div", _hoisted_263, _toDisplayString(day.label), 1 /* TEXT */)
                        ], 8 /* PROPS */, _hoisted_261))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _hoisted_264
                  ])
                ])
              ]),
              _createCommentVNode(" end right column ")
            ]))
          : ($setup.activeTab === 'trophyCase')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createCommentVNode(" end .nge-profile-body (Overview) "),
                _createCommentVNode(" ── Trophy Case tab ─────────────────────────────────── "),
                _createElementVNode("div", _hoisted_265, [
                  _createElementVNode("div", _hoisted_266, [
                    _createElementVNode("div", _hoisted_267, [
                      _createCommentVNode(" ── Featured badge banner ── "),
                      ($setup.selectedSpecialBadge)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_268, [
                            _createElementVNode("div", _hoisted_269, [
                              _hoisted_270,
                              _hoisted_271,
                              _hoisted_272,
                              _hoisted_273,
                              _hoisted_274,
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (i) => {
                                return _createElementVNode("span", {
                                  key: i,
                                  class: "nge-trophy-orbit-dot",
                                  style: _normalizeStyle({ '--j': i })
                                }, null, 4 /* STYLE */)
                              }), 64 /* STABLE_FRAGMENT */)),
                              _hoisted_275
                            ]),
                            _createElementVNode("img", {
                              src: $setup.selectedSpecialBadge.badge?.image_url || $setup.selectedSpecialBadge.badge?.thumbnail_url,
                              alt: $setup.selectedSpecialBadge.badge?.name,
                              class: "nge-trophy-featured-icon nge-trophy-featured-icon--animated",
                              onClick: _cache[21] || (_cache[21] = $event => ($setup.zoomBadge($setup.selectedSpecialBadge.badge?.image_url || $setup.selectedSpecialBadge.badge?.thumbnail_url, $setup.selectedSpecialBadge.badge?.name, $setup.selectedSpecialBadge.badge?.description, 'Won on ' + $setup.formatDate($setup.selectedSpecialBadge.awarded_at))))
                            }, null, 8 /* PROPS */, _hoisted_276),
                            _createElementVNode("div", _hoisted_277, [
                              _createElementVNode("div", _hoisted_278, _toDisplayString($setup.selectedSpecialBadge.badge?.name || 'Award'), 1 /* TEXT */),
                              ($setup.selectedSpecialBadge.badge?.description)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_279, _toDisplayString($setup.selectedSpecialBadge.badge.description), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true),
                              ($setup.medalWins($setup.selectedSpecialBadge))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_280, _toDisplayString($setup.medalWins($setup.selectedSpecialBadge)), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true),
                              _hoisted_281,
                              _createElementVNode("div", _hoisted_282, [
                                _createTextVNode(" Won on "),
                                _createElementVNode("strong", null, _toDisplayString($setup.formatDate($setup.selectedSpecialBadge.awarded_at)), 1 /* TEXT */)
                              ]),
                              ($setup.favoriteBadgeSlug === ($setup.selectedSpecialBadge.badge?.slug || `special-${$setup.selectedSpecialBadge.id}`))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_283, "★ Your favorite badge"))
                                : _createCommentVNode("v-if", true)
                            ]),
                            _createElementVNode("button", {
                              class: _normalizeClass(["nge-trophy-featured-star", { 'nge-trophy-featured-star--active': $setup.favoriteBadgeSlug === ($setup.selectedSpecialBadge.badge?.slug || `special-${$setup.selectedSpecialBadge.id}`) }]),
                              title: $setup.favoriteBadgeSlug === ($setup.selectedSpecialBadge.badge?.slug || `special-${$setup.selectedSpecialBadge.id}`) ? 'Remove from favorites' : 'Set as favorite badge',
                              onClick: _cache[22] || (_cache[22] = $event => ($setup.toggleFavoriteSpecialBadge($setup.selectedSpecialBadge)))
                            }, _toDisplayString($setup.favoriteBadgeSlug === ($setup.selectedSpecialBadge.badge?.slug || `special-${$setup.selectedSpecialBadge.id}`) ? '★' : '☆'), 11 /* TEXT, CLASS, PROPS */, _hoisted_284)
                          ]))
                        : ($setup.favoriteSpecialBadge && !$setup.selectedBadge)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_285, [
                              _createElementVNode("div", _hoisted_286, [
                                _hoisted_287,
                                _hoisted_288,
                                _hoisted_289,
                                _hoisted_290,
                                _hoisted_291,
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (i) => {
                                  return _createElementVNode("span", {
                                    key: i,
                                    class: "nge-trophy-orbit-dot",
                                    style: _normalizeStyle({ '--j': i })
                                  }, null, 4 /* STYLE */)
                                }), 64 /* STABLE_FRAGMENT */)),
                                _hoisted_292
                              ]),
                              _createElementVNode("img", {
                                src: $setup.favoriteSpecialBadge.badge?.image_url || $setup.favoriteSpecialBadge.badge?.thumbnail_url,
                                alt: $setup.favoriteSpecialBadge.badge?.name,
                                class: "nge-trophy-featured-icon nge-trophy-featured-icon--animated",
                                onClick: _cache[23] || (_cache[23] = $event => ($setup.zoomBadge($setup.favoriteSpecialBadge.badge?.image_url || $setup.favoriteSpecialBadge.badge?.thumbnail_url, $setup.favoriteSpecialBadge.badge?.name, $setup.favoriteSpecialBadge.badge?.description, 'Won on ' + $setup.formatDate($setup.favoriteSpecialBadge.awarded_at))))
                              }, null, 8 /* PROPS */, _hoisted_293),
                              _createElementVNode("div", _hoisted_294, [
                                _createElementVNode("div", _hoisted_295, _toDisplayString($setup.favoriteSpecialBadge.badge?.name || 'Award'), 1 /* TEXT */),
                                ($setup.favoriteSpecialBadge.badge?.description)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_296, _toDisplayString($setup.favoriteSpecialBadge.badge.description), 1 /* TEXT */))
                                  : _createCommentVNode("v-if", true),
                                _hoisted_297,
                                _createElementVNode("div", _hoisted_298, [
                                  _createTextVNode(" Won on "),
                                  _createElementVNode("strong", null, _toDisplayString($setup.formatDate($setup.favoriteSpecialBadge.awarded_at)), 1 /* TEXT */)
                                ]),
                                _hoisted_299
                              ]),
                              _createElementVNode("button", {
                                class: "nge-trophy-featured-star nge-trophy-featured-star--active",
                                title: "Remove from favorites",
                                onClick: _cache[24] || (_cache[24] = $event => ($setup.toggleFavoriteSpecialBadge($setup.favoriteSpecialBadge)))
                              }, "★")
                            ]))
                          : ($setup.featuredBadge)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_300, [
                                _createElementVNode("div", _hoisted_301, [
                                  _hoisted_302,
                                  _hoisted_303,
                                  _hoisted_304,
                                  _hoisted_305,
                                  _hoisted_306,
                                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (i) => {
                                    return _createElementVNode("span", {
                                      key: i,
                                      class: "nge-trophy-orbit-dot",
                                      style: _normalizeStyle({ '--j': i })
                                    }, null, 4 /* STYLE */)
                                  }), 64 /* STABLE_FRAGMENT */)),
                                  _hoisted_307
                                ]),
                                _createElementVNode("img", {
                                  src: $setup.getBadgeUrl($setup.featuredBadge.imageKey),
                                  alt: $setup.featuredBadge.name,
                                  class: _normalizeClass(["nge-trophy-featured-icon nge-trophy-featured-icon--animated", `nge-badge--${$setup.featuredBadge.slug}`]),
                                  onClick: _cache[25] || (_cache[25] = $event => ($setup.zoomBadge($setup.getBadgeUrl($setup.featuredBadge.imageKey), $setup.featuredBadge.name, $setup.featuredBadge.description, 'Unlocked at ' + $setup.featuredBadge.threshold.toLocaleString() + ' ' + $setup.thresholdLabel($setup.featuredBadge))))
                                }, null, 10 /* CLASS, PROPS */, _hoisted_308),
                                _createElementVNode("div", _hoisted_309, [
                                  _createElementVNode("div", _hoisted_310, _toDisplayString($setup.featuredBadge.name), 1 /* TEXT */),
                                  _createElementVNode("div", _hoisted_311, _toDisplayString($setup.featuredBadge.description), 1 /* TEXT */),
                                  _createElementVNode("div", _hoisted_312, [
                                    _createTextVNode(" Unlocked at "),
                                    _createElementVNode("strong", null, _toDisplayString($setup.featuredBadge.threshold.toLocaleString()), 1 /* TEXT */),
                                    _createTextVNode(" " + _toDisplayString($setup.thresholdLabel($setup.featuredBadge)), 1 /* TEXT */)
                                  ]),
                                  ($setup.favoriteBadgeSlug === $setup.featuredBadge.slug)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_313, "★ Your favorite badge"))
                                    : _createCommentVNode("v-if", true)
                                ]),
                                _createElementVNode("button", {
                                  class: _normalizeClass(["nge-trophy-featured-star", { 'nge-trophy-featured-star--active': $setup.favoriteBadgeSlug === $setup.featuredBadge.slug }]),
                                  title: $setup.favoriteBadgeSlug === $setup.featuredBadge.slug ? 'Remove from favorites' : 'Set as favorite badge',
                                  onClick: _cache[26] || (_cache[26] = $event => ($setup.toggleFavoriteBadge($setup.featuredBadge)))
                                }, _toDisplayString($setup.favoriteBadgeSlug === $setup.featuredBadge.slug ? '★' : '☆'), 11 /* TEXT, CLASS, PROPS */, _hoisted_314)
                              ]))
                            : _createCommentVNode("v-if", true),
                      _createCommentVNode(" Stars for the badge on show: one gold favorite, up to five silver, up to ten bronze "),
                      (!$setup.viewingOtherUser && $setup.featuredSlug)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_315, [
                            _createElementVNode("button", {
                              class: _normalizeClass(["nge-trophy-starbtn nge-trophy-starbtn--gold", { 'is-on': $setup.featuredIsGold }]),
                              title: $setup.featuredIsGold ? 'Remove the gold star' : 'Make this your one gold favorite, shown on your profile',
                              onClick: $setup.toggleGoldFeatured
                            }, "★ " + _toDisplayString($setup.featuredIsGold ? 'Gold favorite' : 'Make gold'), 11 /* TEXT, CLASS, PROPS */, _hoisted_316),
                            _createElementVNode("button", {
                              class: _normalizeClass(["nge-trophy-starbtn nge-trophy-starbtn--silver", { 'is-on': $setup.featuredIsSilver }]),
                              disabled: !$setup.featuredIsSilver && $setup.silverFull,
                              title: $setup.featuredIsSilver ? 'Remove the silver star' : $setup.silverFull ? 'Five silver favorites is the limit. Remove one first.' : 'Add to your silver favorites',
                              onClick: $setup.toggleSilverFeatured
                            }, "★ " + _toDisplayString($setup.featuredIsSilver ? 'Silver favorite' : 'Add silver'), 11 /* TEXT, CLASS, PROPS */, _hoisted_317),
                            _createElementVNode("button", {
                              class: _normalizeClass(["nge-trophy-starbtn nge-trophy-starbtn--bronze", { 'is-on': $setup.featuredIsBronze }]),
                              disabled: !$setup.featuredIsBronze && $setup.bronzeFull,
                              title: $setup.featuredIsBronze ? 'Remove the bronze star' : $setup.bronzeFull ? 'Ten bronze favorites is the limit. Remove one first.' : 'Add to your bronze favorites',
                              onClick: $setup.toggleBronzeFeatured
                            }, "★ " + _toDisplayString($setup.featuredIsBronze ? 'Bronze favorite' : 'Add bronze'), 11 /* TEXT, CLASS, PROPS */, _hoisted_318)
                          ]))
                        : _createCommentVNode("v-if", true),
                      ($setup.favoriteRow.length || !$setup.viewingOtherUser)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_319, [
                            _hoisted_320,
                            ($setup.favoriteRow.length)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("div", _hoisted_321, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.favoriteRow.filter(x => x.tier !== 'bronze'), (f) => {
                                      return (_openBlock(), _createElementBlock("button", {
                                        key: f.slug,
                                        class: _normalizeClass(["nge-trophy-fav", { 'nge-trophy-fav--gold': f.gold, 'is-shown': $setup.featuredSlug === f.slug, 'is-dragging': $setup.draggingFav?.slug === f.slug, 'is-drop': $setup.dropFav === f.slug }]),
                                        draggable: $setup.favDraggable(f),
                                        onDragstart: $event => ($setup.favDragStart(f, $event)),
                                        onDragover: $event => ($setup.favDragOver(f, $event)),
                                        onDrop: _withModifiers($event => ($setup.favDrop(f)), ["prevent"]),
                                        onDragend: $setup.favDragEnd,
                                        title: f.name + (f.gold ? ', gold favorite' : ', silver favorite' + ($setup.viewingOtherUser ? '' : '. Drag to reorder.')),
                                        onClick: $event => ($setup.openFavorite(f))
                                      }, [
                                        _createElementVNode("img", {
                                          src: f.img,
                                          alt: f.name
                                        }, null, 8 /* PROPS */, _hoisted_323),
                                        _hoisted_324
                                      ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_322))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ]),
                                  ($setup.bronzeRow.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_325, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.bronzeRow, (f) => {
                                          return (_openBlock(), _createElementBlock("button", {
                                            key: f.slug,
                                            class: _normalizeClass(["nge-trophy-fav nge-trophy-fav--bronze", { 'is-shown': $setup.featuredSlug === f.slug, 'is-dragging': $setup.draggingFav?.slug === f.slug, 'is-drop': $setup.dropFav === f.slug }]),
                                            draggable: $setup.favDraggable(f),
                                            onDragstart: $event => ($setup.favDragStart(f, $event)),
                                            onDragover: $event => ($setup.favDragOver(f, $event)),
                                            onDrop: _withModifiers($event => ($setup.favDrop(f)), ["prevent"]),
                                            onDragend: $setup.favDragEnd,
                                            title: f.name + ', bronze favorite' + ($setup.viewingOtherUser ? '' : '. Drag to reorder.'),
                                            onClick: $event => ($setup.openFavorite(f))
                                          }, [
                                            _createElementVNode("img", {
                                              src: f.img,
                                              alt: f.name
                                            }, null, 8 /* PROPS */, _hoisted_327),
                                            _hoisted_328
                                          ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_326))
                                        }), 128 /* KEYED_FRAGMENT */))
                                      ]))
                                    : _createCommentVNode("v-if", true)
                                ], 64 /* STABLE_FRAGMENT */))
                              : (_openBlock(), _createElementBlock("div", _hoisted_329, "Pick a badge on the right, then star it."))
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createCommentVNode(" end side "),
                    _createElementVNode("div", _hoisted_330, [
                      _createCommentVNode(" Exploration track (Cell Achievements first) "),
                      _createElementVNode("div", {
                        class: _normalizeClass(["nge-trophy-track", { 'is-dragging': $setup.draggingSection === 'cells', 'is-drop': $setup.dropSection === 'cells' }]),
                        style: _normalizeStyle($setup.sectionOrder('cells')),
                        onDragover: _cache[30] || (_cache[30] = $event => ($setup.sectionDragOver('cells', $event))),
                        onDrop: _cache[31] || (_cache[31] = _withModifiers($event => ($setup.sectionDrop('cells')), ["prevent"]))
                      }, [
                        _createElementVNode("div", _hoisted_331, [
                          _createTextVNode("Cell Completions "),
                          _createElementVNode("span", _hoisted_332, _toDisplayString($setup.earnedExplorationBadges.earned.length) + " earned", 1 /* TEXT */),
                          (!$setup.viewingOtherUser)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_333, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "nge-trophy-track-grip",
                                  draggable: "true",
                                  title: "Drag to move this section",
                                  "aria-label": "Drag to move this section",
                                  onDragstart: _cache[27] || (_cache[27] = $event => ($setup.sectionDragStart('cells', $event))),
                                  onDragend: $setup.sectionDragEnd
                                }, "⠿", 32 /* HYDRATE_EVENTS */),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "nge-trophy-track-nudge",
                                  title: "Move up",
                                  "aria-label": "Move this section up",
                                  onClick: _cache[28] || (_cache[28] = $event => ($setup.moveSection('cells', -1)))
                                }, "▲"),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "nge-trophy-track-nudge",
                                  title: "Move down",
                                  "aria-label": "Move this section down",
                                  onClick: _cache[29] || (_cache[29] = $event => ($setup.moveSection('cells', 1)))
                                }, "▼")
                              ]))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _createElementVNode("div", _hoisted_334, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.earnedExplorationBadges.earned, (badge) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: badge.id,
                              class: _normalizeClass(["nge-trophy-badge nge-trophy-badge--exploration", {
                  'nge-trophy-badge--selected': $setup.selectedBadge?.id === badge.id,
                  'nge-trophy-badge--favorited': $setup.favoriteBadgeSlug === badge.slug,
                  'nge-trophy-badge--silver': $setup.silverSlugs.includes(badge.slug),
                  'nge-trophy-badge--bronze': $setup.bronzeSlugs.includes(badge.slug),
                }]),
                              title: `${badge.name}: ${badge.threshold.toLocaleString()} cells`,
                              onClick: $event => ($setup.onBadgeClick(badge))
                            }, [
                              _createElementVNode("img", {
                                src: $setup.getBadgeUrl(badge.imageKey),
                                alt: badge.name,
                                class: _normalizeClass(["nge-trophy-badge-icon", `nge-badge--${badge.slug}`])
                              }, null, 10 /* CLASS, PROPS */, _hoisted_336),
                              _createElementVNode("div", _hoisted_337, _toDisplayString(badge.name), 1 /* TEXT */),
                              _createElementVNode("div", _hoisted_338, _toDisplayString(badge.threshold.toLocaleString()) + " cells", 1 /* TEXT */)
                            ], 10 /* CLASS, PROPS */, _hoisted_335))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ], 38 /* CLASS, STYLE, HYDRATE_EVENTS */),
                      _createCommentVNode(" Proofreading track "),
                      _createElementVNode("div", {
                        class: _normalizeClass(["nge-trophy-track", { 'is-dragging': $setup.draggingSection === 'editor', 'is-drop': $setup.dropSection === 'editor' }]),
                        style: _normalizeStyle($setup.sectionOrder('editor')),
                        onDragover: _cache[35] || (_cache[35] = $event => ($setup.sectionDragOver('editor', $event))),
                        onDrop: _cache[36] || (_cache[36] = _withModifiers($event => ($setup.sectionDrop('editor')), ["prevent"]))
                      }, [
                        _createElementVNode("div", _hoisted_339, [
                          _createTextVNode("Editor Achievements "),
                          _createElementVNode("span", _hoisted_340, _toDisplayString($setup.earnedBuildingBadges.earned.length) + " earned", 1 /* TEXT */),
                          (!$setup.viewingOtherUser)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_341, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "nge-trophy-track-grip",
                                  draggable: "true",
                                  title: "Drag to move this section",
                                  "aria-label": "Drag to move this section",
                                  onDragstart: _cache[32] || (_cache[32] = $event => ($setup.sectionDragStart('editor', $event))),
                                  onDragend: $setup.sectionDragEnd
                                }, "⠿", 32 /* HYDRATE_EVENTS */),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "nge-trophy-track-nudge",
                                  title: "Move up",
                                  "aria-label": "Move this section up",
                                  onClick: _cache[33] || (_cache[33] = $event => ($setup.moveSection('editor', -1)))
                                }, "▲"),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "nge-trophy-track-nudge",
                                  title: "Move down",
                                  "aria-label": "Move this section down",
                                  onClick: _cache[34] || (_cache[34] = $event => ($setup.moveSection('editor', 1)))
                                }, "▼")
                              ]))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _createElementVNode("div", _hoisted_342, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.earnedBuildingBadges.earned, (badge) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: badge.id,
                              class: _normalizeClass(["nge-trophy-badge nge-trophy-badge--building", {
                  'nge-trophy-badge--selected': $setup.selectedBadge?.id === badge.id,
                  'nge-trophy-badge--favorited': $setup.favoriteBadgeSlug === badge.slug,
                  'nge-trophy-badge--silver': $setup.silverSlugs.includes(badge.slug),
                  'nge-trophy-badge--bronze': $setup.bronzeSlugs.includes(badge.slug),
                }]),
                              title: `${badge.name}: ${badge.threshold.toLocaleString()} edits`,
                              onClick: $event => ($setup.onBadgeClick(badge))
                            }, [
                              _createElementVNode("img", {
                                src: $setup.getBadgeUrl(badge.imageKey),
                                alt: badge.name,
                                class: _normalizeClass(["nge-trophy-badge-icon", `nge-badge--${badge.slug}`])
                              }, null, 10 /* CLASS, PROPS */, _hoisted_344),
                              _createElementVNode("div", _hoisted_345, _toDisplayString(badge.name), 1 /* TEXT */),
                              _createElementVNode("div", _hoisted_346, _toDisplayString(badge.threshold.toLocaleString()) + " edits", 1 /* TEXT */)
                            ], 10 /* CLASS, PROPS */, _hoisted_343))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ], 38 /* CLASS, STYLE, HYDRATE_EVENTS */),
                      _createCommentVNode(" Loyalty track "),
                      ($setup.earnedLoyaltyBadges.earned.length > 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["nge-trophy-track", { 'is-dragging': $setup.draggingSection === 'loyalty', 'is-drop': $setup.dropSection === 'loyalty' }]),
                            style: _normalizeStyle($setup.sectionOrder('loyalty')),
                            onDragover: _cache[40] || (_cache[40] = $event => ($setup.sectionDragOver('loyalty', $event))),
                            onDrop: _cache[41] || (_cache[41] = _withModifiers($event => ($setup.sectionDrop('loyalty')), ["prevent"]))
                          }, [
                            _createElementVNode("div", _hoisted_347, [
                              _createTextVNode("Loyalty Achievements "),
                              _createElementVNode("span", _hoisted_348, _toDisplayString($setup.earnedLoyaltyBadges.earned.length) + " earned", 1 /* TEXT */),
                              (!$setup.viewingOtherUser)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_349, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "nge-trophy-track-grip",
                                      draggable: "true",
                                      title: "Drag to move this section",
                                      "aria-label": "Drag to move this section",
                                      onDragstart: _cache[37] || (_cache[37] = $event => ($setup.sectionDragStart('loyalty', $event))),
                                      onDragend: $setup.sectionDragEnd
                                    }, "⠿", 32 /* HYDRATE_EVENTS */),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "nge-trophy-track-nudge",
                                      title: "Move up",
                                      "aria-label": "Move this section up",
                                      onClick: _cache[38] || (_cache[38] = $event => ($setup.moveSection('loyalty', -1)))
                                    }, "▲"),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "nge-trophy-track-nudge",
                                      title: "Move down",
                                      "aria-label": "Move this section down",
                                      onClick: _cache[39] || (_cache[39] = $event => ($setup.moveSection('loyalty', 1)))
                                    }, "▼")
                                  ]))
                                : _createCommentVNode("v-if", true)
                            ]),
                            _createElementVNode("div", _hoisted_350, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.earnedLoyaltyBadges.earned, (badge) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: badge.id,
                                  class: _normalizeClass(["nge-trophy-badge nge-trophy-badge--loyalty", {
                  'nge-trophy-badge--selected': $setup.selectedBadge?.id === badge.id,
                  'nge-trophy-badge--favorited': $setup.favoriteBadgeSlug === badge.slug,
                  'nge-trophy-badge--silver': $setup.silverSlugs.includes(badge.slug),
                  'nge-trophy-badge--bronze': $setup.bronzeSlugs.includes(badge.slug),
                }]),
                                  title: `${badge.name}: ${badge.threshold} days of science`,
                                  onClick: $event => ($setup.onBadgeClick(badge))
                                }, [
                                  _createElementVNode("img", {
                                    src: $setup.getBadgeUrl(badge.imageKey),
                                    alt: badge.name,
                                    class: _normalizeClass(["nge-trophy-badge-icon", `nge-badge--${badge.slug}`])
                                  }, null, 10 /* CLASS, PROPS */, _hoisted_352),
                                  _createElementVNode("div", _hoisted_353, _toDisplayString(badge.name), 1 /* TEXT */),
                                  _createElementVNode("div", _hoisted_354, _toDisplayString(badge.threshold) + " days of science", 1 /* TEXT */)
                                ], 10 /* CLASS, PROPS */, _hoisted_351))
                              }), 128 /* KEYED_FRAGMENT */))
                            ])
                          ], 38 /* CLASS, STYLE, HYDRATE_EVENTS */))
                        : _createCommentVNode("v-if", true),
                      _createCommentVNode(" Competitions "),
                      ($setup.competitionMedals.length)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: _normalizeClass(["nge-trophy-track", { 'is-dragging': $setup.draggingSection === 'competitions', 'is-drop': $setup.dropSection === 'competitions' }]),
                            style: _normalizeStyle($setup.sectionOrder('competitions')),
                            onDragover: _cache[45] || (_cache[45] = $event => ($setup.sectionDragOver('competitions', $event))),
                            onDrop: _cache[46] || (_cache[46] = _withModifiers($event => ($setup.sectionDrop('competitions')), ["prevent"]))
                          }, [
                            _createElementVNode("div", _hoisted_355, [
                              _createTextVNode("◆ Competitions "),
                              (!$setup.viewingOtherUser)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_356, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "nge-trophy-track-grip",
                                      draggable: "true",
                                      title: "Drag to move this section",
                                      "aria-label": "Drag to move this section",
                                      onDragstart: _cache[42] || (_cache[42] = $event => ($setup.sectionDragStart('competitions', $event))),
                                      onDragend: $setup.sectionDragEnd
                                    }, "⠿", 32 /* HYDRATE_EVENTS */),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "nge-trophy-track-nudge",
                                      title: "Move up",
                                      "aria-label": "Move this section up",
                                      onClick: _cache[43] || (_cache[43] = $event => ($setup.moveSection('competitions', -1)))
                                    }, "▲"),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "nge-trophy-track-nudge",
                                      title: "Move down",
                                      "aria-label": "Move this section down",
                                      onClick: _cache[44] || (_cache[44] = $event => ($setup.moveSection('competitions', 1)))
                                    }, "▼")
                                  ]))
                                : _createCommentVNode("v-if", true)
                            ]),
                            _createElementVNode("div", _hoisted_357, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.competitionMedals, (m) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: m.tier,
                                  class: _normalizeClass(["nge-trophy-badge nge-trophy-badge--medal", { 'nge-trophy-badge--selected': $setup.medalSelected(m) }]),
                                  title: $setup.medalTooltip(m),
                                  onClick: $event => ($setup.onMedalClick(m))
                                }, [
                                  _createElementVNode("span", _hoisted_359, [
                                    _createElementVNode("img", {
                                      src: $setup.medalArt(m),
                                      alt: $setup.MEDAL_WORD[m.tier],
                                      class: "nge-trophy-badge-icon"
                                    }, null, 8 /* PROPS */, _hoisted_360),
                                    (m.count > 1)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          class: "nge-medal-count",
                                          "aria-label": `won ${m.count} times`
                                        }, "×" + _toDisplayString(m.count), 9 /* TEXT, PROPS */, _hoisted_361))
                                      : _createCommentVNode("v-if", true)
                                  ]),
                                  _createElementVNode("div", _hoisted_362, _toDisplayString($setup.MEDAL_WORD[m.tier]), 1 /* TEXT */),
                                  ($setup.MEDAL_SUB[m.tier])
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_363, _toDisplayString($setup.MEDAL_SUB[m.tier]), 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true)
                                ], 10 /* CLASS, PROPS */, _hoisted_358))
                              }), 128 /* KEYED_FRAGMENT */))
                            ])
                          ], 38 /* CLASS, STYLE, HYDRATE_EVENTS */))
                        : _createCommentVNode("v-if", true),
                      _createCommentVNode(" Special Awards "),
                      ($setup.plainSpecialBadges.length > 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: _normalizeClass(["nge-trophy-track", { 'is-dragging': $setup.draggingSection === 'special', 'is-drop': $setup.dropSection === 'special' }]),
                            style: _normalizeStyle($setup.sectionOrder('special')),
                            onDragover: _cache[50] || (_cache[50] = $event => ($setup.sectionDragOver('special', $event))),
                            onDrop: _cache[51] || (_cache[51] = _withModifiers($event => ($setup.sectionDrop('special')), ["prevent"]))
                          }, [
                            _createElementVNode("div", _hoisted_364, [
                              _createTextVNode("★ Special Awards "),
                              (!$setup.viewingOtherUser)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_365, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "nge-trophy-track-grip",
                                      draggable: "true",
                                      title: "Drag to move this section",
                                      "aria-label": "Drag to move this section",
                                      onDragstart: _cache[47] || (_cache[47] = $event => ($setup.sectionDragStart('special', $event))),
                                      onDragend: $setup.sectionDragEnd
                                    }, "⠿", 32 /* HYDRATE_EVENTS */),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "nge-trophy-track-nudge",
                                      title: "Move up",
                                      "aria-label": "Move this section up",
                                      onClick: _cache[48] || (_cache[48] = $event => ($setup.moveSection('special', -1)))
                                    }, "▲"),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "nge-trophy-track-nudge",
                                      title: "Move down",
                                      "aria-label": "Move this section down",
                                      onClick: _cache[49] || (_cache[49] = $event => ($setup.moveSection('special', 1)))
                                    }, "▼")
                                  ]))
                                : _createCommentVNode("v-if", true)
                            ]),
                            _createElementVNode("div", _hoisted_366, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.plainSpecialBadges, (award) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: award.id,
                                  class: _normalizeClass(["nge-trophy-badge", { 'nge-trophy-badge--selected': $setup.selectedSpecialBadge?.id === award.id, 'nge-trophy-badge--favorited': $setup.favoriteBadgeSlug === $setup.specialSlug(award), 'nge-trophy-badge--silver': $setup.silverSlugs.includes($setup.specialSlug(award)), 'nge-trophy-badge--bronze': $setup.bronzeSlugs.includes($setup.specialSlug(award)) }]),
                                  title: $setup.specialBadgeTooltip(award),
                                  onClick: $event => ($setup.onSpecialBadgeClick(award))
                                }, [
                                  _createElementVNode("img", {
                                    src: award.badge?.thumbnail_url || award.badge?.image_url,
                                    alt: award.badge?.name,
                                    class: "nge-trophy-badge-icon"
                                  }, null, 8 /* PROPS */, _hoisted_368),
                                  _createElementVNode("div", _hoisted_369, _toDisplayString(award.badge?.name || 'Award'), 1 /* TEXT */)
                                ], 10 /* CLASS, PROPS */, _hoisted_367))
                              }), 128 /* KEYED_FRAGMENT */))
                            ])
                          ], 38 /* CLASS, STYLE, HYDRATE_EVENTS */))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createCommentVNode(" end main ")
                  ])
                ])
              ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
            : _createCommentVNode("v-if", true),
        _createCommentVNode(" end Trophy Case "),
        _createCommentVNode(" ── My Cells: claims and completions by dataset, loaded on open ── "),
        ($setup.activeTab === 'myCells')
          ? (_openBlock(), _createElementBlock("div", _hoisted_370, [
              (_openBlock(), _createBlock($setup["MyCellsTab"], {
                key: $setup.props.viewUserId || $setup.backendStore.userId || '',
                "user-id": $setup.props.viewUserId || $setup.backendStore.userId,
                "is-self": !$setup.viewingOtherUser,
                onJumped: $setup.handleClose
              }, null, 8 /* PROPS */, ["user-id", "is-self"]))
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" ── Datasets tab: contributions per dataset + switcher ── "),
        ($setup.activeTab === 'datasets')
          ? (_openBlock(), _createElementBlock("div", _hoisted_371, [
              _createElementVNode("div", _hoisted_372, _toDisplayString($setup.viewingOtherUser ? `The datasets ${$setup.profileName} has contributed to.` : 'The datasets you have contributed to.') + " Click one to switch your viewer to it. ", 1 /* TEXT */),
              ($setup.accessRows.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_373, [
                    _hoisted_374,
                    _createElementVNode("div", _hoisted_375, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.accessRows, (r) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: r.id,
                          class: _normalizeClass(["nge-ds-access-tile", 'nge-ds-access-tile--' + r.state]),
                          title: r.state === 'edit' ? `${r.label}: edit access${r.when ? ` since ${r.when}` : ''}` : r.state === 'locked' ? ($setup.viewingOtherUser ? `${r.label}: not unlocked yet` : `${r.label}: not unlocked yet. Pass the edit test, then Ask for Edit Access in the menu.`) : `${r.label}: checking…`
                        }, [
                          _createElementVNode("img", {
                            src: r.state === 'edit' ? $setup.unlockIcon : $setup.lockIcon,
                            class: "nge-ds-access-icon",
                            alt: "",
                            draggable: "false"
                          }, null, 8 /* PROPS */, _hoisted_377),
                          _createElementVNode("span", _hoisted_378, [
                            _createElementVNode("span", _hoisted_379, _toDisplayString(r.name), 1 /* TEXT */),
                            _createElementVNode("span", _hoisted_380, _toDisplayString(r.state === 'edit' ? (r.when ? `Unlocked · ${r.when}` : 'Unlocked') : r.state === 'locked' ? 'Locked' : 'Checking'), 1 /* TEXT */)
                          ])
                        ], 10 /* CLASS, PROPS */, _hoisted_376))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("button", {
                class: "nge-ds-tab-progress",
                onClick: $setup.openDatasetProgress
              }, "Dataset stats: what has been done on each dataset →"),
              ($setup.datasetStatsLoading && !Object.keys($setup.datasetStats).length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_381, " Counting edits… "))
                : _createCommentVNode("v-if", true),
              (!$setup.contributedDatasets.length && !$setup.datasetStatsLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_382, _toDisplayString($setup.viewingOtherUser ? 'No contributions yet.' : 'No contributions yet. Your datasets appear here once you make an edit or complete a cell.'), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_383, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.contributedDatasets, (ds) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: ds.id,
                    class: _normalizeClass(["nge-ds-tab-card", {
              'nge-ds-tab-card--active': $setup.canonicalDataset($setup.segLayerName(ds)) === $setup.activeDatasetCanon,
              'nge-ds-tab-card--switching': $setup.switchingDatasetId === ds.id,
              'nge-ds-tab-card--thumb': !!ds.thumbnail,
            }]),
                    onClick: $event => ($setup.switchProfileDataset(ds))
                  }, [
                    (ds.thumbnail)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: ds.thumbnail,
                          class: "nge-ds-tab-thumb",
                          alt: "",
                          loading: "lazy"
                        }, null, 8 /* PROPS */, _hoisted_385))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_386, [
                      _createElementVNode("div", _hoisted_387, [
                        (!ds.thumbnail)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_388, _toDisplayString($setup.SPECIES_ICONS[ds.species]), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("span", _hoisted_389, _toDisplayString(ds.label), 1 /* TEXT */),
                        ($setup.canonicalDataset($setup.segLayerName(ds)) === $setup.activeDatasetCanon)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_390, "Active"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_391, "Switch ▸"))
                      ]),
                      _createElementVNode("div", _hoisted_392, [
                        _createTextVNode(_toDisplayString(ds.description), 1 /* TEXT */),
                        (ds.origin)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_393, " · From " + _toDisplayString(ds.origin), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createElementVNode("div", _hoisted_394, [
                        ($setup.datasetContribution(ds))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              ($setup.showsAllStats(ds) || $setup.datasetContribution(ds)?.edits)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_395, [
                                    _createElementVNode("b", null, _toDisplayString(($setup.datasetContribution(ds)?.edits ?? 0).toLocaleString()), 1 /* TEXT */),
                                    _createTextVNode(" edits")
                                  ]))
                                : _createCommentVNode("v-if", true),
                              ($setup.showsAllStats(ds) || $setup.datasetContribution(ds)?.completions || !$setup.datasetContribution(ds)?.outside)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 1,
                                    class: _normalizeClass(["nge-ds-tab-stat", { 'nge-ds-tab-stat--cells': $setup.datasetContribution(ds)?.completions }])
                                  }, [
                                    _createElementVNode("b", null, _toDisplayString(($setup.datasetContribution(ds)?.completions ?? 0).toLocaleString()), 1 /* TEXT */),
                                    _createTextVNode(" cells completed")
                                  ], 2 /* CLASS */))
                                : _createCommentVNode("v-if", true),
                              _createCommentVNode(" Work the dataset's own records credit to this player, done in other\n                     tools. Shown here only: it counts toward nothing (Ames 2026-10-07). "),
                              ($setup.datasetContribution(ds)?.outside)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_396, [
                                    _createElementVNode("b", null, _toDisplayString(($setup.datasetContribution(ds)?.outside ?? 0).toLocaleString()), 1 /* TEXT */),
                                    _createTextVNode(" cells proofread outside the game")
                                  ]))
                                : _createCommentVNode("v-if", true),
                              ($setup.showsAllStats(ds) || $setup.datasetContribution(ds)?.helpRequests)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_397, [
                                    _createElementVNode("b", null, _toDisplayString(($setup.datasetContribution(ds)?.helpRequests ?? 0).toLocaleString()), 1 /* TEXT */),
                                    _createTextVNode(" help requests")
                                  ]))
                                : _createCommentVNode("v-if", true),
                              (!$setup.hasContributed(ds))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_398, "no contributions yet"))
                                : _createCommentVNode("v-if", true)
                            ], 64 /* STABLE_FRAGMENT */))
                          : (_openBlock(), _createElementBlock("span", _hoisted_399, "…"))
                      ])
                    ])
                  ], 10 /* CLASS, PROPS */, _hoisted_384))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" More datasets (Ames 2026-10-06): optional, explore only volumes\n           each player can add to their own switcher. "),
        ($setup.activeTab === 'datasets' && !$setup.viewingOtherUser)
          ? (_openBlock(), _createElementBlock("div", _hoisted_400, [
              _hoisted_401,
              _hoisted_402,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.DATASETS.filter(d => d.optional && !d.hidden), (ds) => {
                return (_openBlock(), _createElementBlock("label", {
                  key: ds.id,
                  class: "nge-ds-more-row"
                }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    checked: $setup.extraOn(ds.id),
                    onChange: $event => ($setup.toggleExtra(ds.id, $event))
                  }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_403),
                  _createElementVNode("span", _hoisted_404, _toDisplayString($setup.SPECIES_ICONS[ds.species]), 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_405, [
                    _createElementVNode("span", _hoisted_406, _toDisplayString(ds.label), 1 /* TEXT */),
                    _createElementVNode("span", _hoisted_407, [
                      _createTextVNode(_toDisplayString(ds.description), 1 /* TEXT */),
                      (ds.origin)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_408, " · From " + _toDisplayString(ds.origin), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ])
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" ── Dataset Stats tab ─────────────────────────────────── "),
        ($setup.activeTab === 'datasetStats')
          ? (_openBlock(), _createElementBlock("div", _hoisted_409, [
              _createVNode($setup["DatasetStatsPanel"], {
                embedded: "",
                person: $setup.datasetStatsPerson
              }, null, 8 /* PROPS */, ["person"])
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" ── Week in Science tab ───────────────────────────────── "),
        ($setup.activeTab === 'weekInScience')
          ? (_openBlock(), _createElementBlock("div", _hoisted_410, [
              _createVNode($setup["WeeklyRecapPanel"], { embedded: "" })
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" ── Admin Hub tab ─────────────────────────────────────── "),
        ($setup.activeTab === 'adminHub')
          ? (_openBlock(), _createElementBlock("div", _hoisted_411, [
              _createVNode($setup["AdminHub"], { "initial-sub-tab": $setup.adminInitialSubTab }, null, 8 /* PROPS */, ["initial-sub-tab"])
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" ── Blog tab (listed authors only) ────────────────────── "),
        ($setup.activeTab === 'blog')
          ? (_openBlock(), _createElementBlock("div", _hoisted_412, [
              _createVNode($setup["BlogEditor"])
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" ── Settings tab ──────────────────────────────────────── "),
        ($setup.activeTab === 'settings')
          ? (_openBlock(), _createElementBlock("div", _hoisted_413, [
              _createVNode($setup["SettingsPanel"], {
                embedded: "",
                onHide: _cache[52] || (_cache[52] = $event => ($setup.emit('hide')))
              })
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" ── All Special Awards modal ── "),
        ($setup.showAllSpecialModal)
          ? (_openBlock(), _createElementBlock("div", {
              key: 10,
              class: "nge-special-modal-backdrop",
              onClick: _cache[54] || (_cache[54] = _withModifiers($event => ($setup.showAllSpecialModal = false), ["self"]))
            }, [
              _createElementVNode("div", _hoisted_414, [
                _createElementVNode("div", _hoisted_415, [
                  _hoisted_416,
                  _createElementVNode("button", {
                    class: "nge-special-modal-close",
                    onClick: _cache[53] || (_cache[53] = $event => ($setup.showAllSpecialModal = false))
                  }, "×")
                ]),
                _createElementVNode("div", _hoisted_417, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.plainSpecialBadges, (award) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: award.id,
                      class: "nge-special-modal-tile",
                      title: $setup.specialBadgeTooltip(award),
                      onClick: $event => {$setup.onSpecialBadgeClick(award); $setup.showAllSpecialModal = false;}
                    }, [
                      _createElementVNode("img", {
                        src: award.badge?.thumbnail_url || award.badge?.image_url,
                        alt: award.badge?.name,
                        class: "nge-special-modal-icon"
                      }, null, 8 /* PROPS */, _hoisted_419),
                      _createElementVNode("div", _hoisted_420, _toDisplayString(award.badge?.name || 'Award'), 1 /* TEXT */),
                      (award.reason)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_421, _toDisplayString(award.reason), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ], 8 /* PROPS */, _hoisted_418))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */),
      _createCommentVNode(" Mobile fullscreen badge viewer: tap the featured badge art to see\n         it big, with a simplified award moment. Tap anywhere to close. "),
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        _createVNode(_Transition, { name: "nge-bz" }, {
          default: _withCtx(() => [
            ($setup.badgeZoom)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "nge-badge-zoom",
                  onClick: _cache[55] || (_cache[55] = $event => ($setup.badgeZoom = null))
                }, [
                  _hoisted_422,
                  _hoisted_423,
                  _createElementVNode("img", {
                    src: $setup.badgeZoom.img,
                    alt: $setup.badgeZoom.name,
                    class: "nge-badge-zoom-img"
                  }, null, 8 /* PROPS */, _hoisted_424),
                  _createElementVNode("div", _hoisted_425, _toDisplayString($setup.badgeZoom.name), 1 /* TEXT */),
                  ($setup.badgeZoom.desc)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_426, _toDisplayString($setup.badgeZoom.desc), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  ($setup.badgeZoom.meta)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_427, _toDisplayString($setup.badgeZoom.meta), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  _hoisted_428
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        })
      ]))
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class"]))
}